/*
  Workwear Supermarket colour map
  Generated from cleaned store colour values.
  Space-only names stay as single colours, e.g. Deep Green, Grey Melange, French Navy.
  True combo separators can return gradients: /, +, &, ' and ', ' with ', ' - '.
*/

window.WSM_COLOUR_MAP = {
  "academy-graphite": "#2f3437",
  "academy-navy": "#14213d",
  "academy-navy-steel": "#71797e",
  "academy-purple": "#5b21b6",
  "academynavy": "#14213d",
  "academypurple": "#5b21b6",
  "acid-lime": "#bfff00",
  "acid-wash": "#6b7280",
  "acidlime": "#bfff00",
  "active-green": "#00a651",
  "active-pink": "#ff69b4",
  "activegreen": "#00a651",
  "activepink": "#ff69b4",
  "air-blue": "#89cff0",
  "air-force-blue": "#5d8aa8",
  "airblue": "#89cff0",
  "airforce-blue": "#5d8aa8",
  "airforce-blue-black": "#0b0b0b",
  "airforceblue": "#5d8aa8",
  "alert-red": "#e11d48",
  "alertred": "#e11d48",
  "alloy": "#98979a",
  "almond": "#eed9c4",
  "almond-marl": "#eed9c4",
  "almond-pistachio-dusty-green": "#047857",
  "almondmarl": "#eed9c4",
  "aloe": "#c7e6c5",
  "aloe-green": "#c7e6c5",
  "aloegreen": "#c7e6c5",
  "alpina-multicam": "#5f6f52",
  "alpinamulticam": "#5f6f52",
  "alpine-blues": "#1d4ed8",
  "alpine-lodge": "#8a865d",
  "alpine-peaks": "#b8b8b8",
  "alpine-racer": "#1d4ed8",
  "amafi-blue": "#2596be",
  "amafiblue": "#2596be",
  "amalfi-blue": "#2596be",
  "amalfi-coral": "#ff7f50",
  "amalfi-green": "#0f766e",
  "amalfi-grey": "#737373",
  "amalfi-teal": "#1b8a8f",
  "amalfi-yellow": "#f4ff15",
  "amalfiblue": "#2596be",
  "amalficoral": "#ff7f50",
  "amalfigreen": "#0f766e",
  "amalfiteal": "#1b8a8f",
  "amazon-green": "#047857",
  "amazongreen": "#047857",
  "amber": "#ffbf00",
  "amethyst": "#9966cc",
  "anthracite": "#25282a",
  "anthracite-black": "#0b0b0b",
  "anthracite-marl": "#9ca3af",
  "anthracite-melange": "#333333",
  "anthracitemelange": "#333333",
  "antique-cherry-red": "#9f1239",
  "antique-gold": "#b8860b",
  "antique-grey": "#737373",
  "antique-irish-green": "#009e60",
  "antique-jade-dome": "#00a86b",
  "antique-moss-green": "#8a9a5b",
  "antique-orange": "#cc5500",
  "antique-red": "#9f1239",
  "antique-sapphire": "#0f52ba",
  "antiquecherryred": "#9f1239",
  "antiquegold": "#b8860b",
  "antiquejadedome": "#00a86b",
  "antiquemossgreen": "#8a9a5b",
  "antiqueorange": "#cc5500",
  "antiquered": "#9f1239",
  "apple": "#8db600",
  "apple-green": "#8db600",
  "applegreen": "#8db600",
  "apricot": "#fbceb1",
  "apricot-agate": "#fbceb1",
  "apricot-agate-black": "#0b0b0b",
  "apricotagate": "#fbceb1",
  "aqua": "#00ffff",
  "aqua-black": "#0b0b0b",
  "aqua-blue": "#00bcd4",
  "aqua-green": "#2dd4bf",
  "aqua-grey": "#737373",
  "aquablue": "#00bcd4",
  "aquagreen": "#2dd4bf",
  "arctic-camo": "#b7c9d6",
  "arctic-dawn": "#d8efff",
  "arctic-orange": "#ff7900",
  "arctic-orange-obsidian": "#111827",
  "arctic-white": "#ffffff",
  "arctic-white-fire-red": "#e11d48",
  "arctic-white-jet-black": "#050505",
  "arctic-white-sapphire-blue": "#0f52ba",
  "arcticcamo": "#b7c9d6",
  "arcticorange": "#ff7900",
  "arcticwhite": "#ffffff",
  "arid": "#c2b280",
  "arid-brown": "#6b4f3a",
  "army": "#4b5320",
  "army-green": "#4b5320",
  "armygreen": "#4b5320",
  "ash": "#b2beb5",
  "ash-black": "#0b0b0b",
  "ash-granite": "#6b7280",
  "ash-grey": "#b2beb5",
  "ash-heather": "#b2beb5",
  "ash-marl-black": "#9ca3af",
  "ash-rio-red": "#ef1b1b",
  "ash-white": "#ffffff",
  "ashen-slate-obsidian": "#111827",
  "ashgrey": "#b2beb5",
  "ashheather": "#b2beb5",
  "asphalt": "#343434",
  "asphalt-black": "#0b0b0b",
  "assorted": "#999999",
  "assorted-navy-khaki": "#8a865d",
  "athletic-grey-triblend": "#9ca3af",
  "athletic-heather": "#9ca3af",
  "athletic-heather-black": "#9ca3af",
  "athleticgreytriblend": "#9ca3af",
  "athleticheather": "#9ca3af",
  "atlantic": "#1f6f8b",
  "atlantic-blue": "#1f6f8b",
  "atlanticblue": "#1f6f8b",
  "atoll": "#00a9b7",
  "au-nat-multi": "#999999",
  "aubergine": "#3d0734",
  "autumn-moss": "#6b6a4a",
  "autumnmoss": "#6b6a4a",
  "azalea": "#ff69b4",
  "azure": "#007fff",
  "azure-black": "#0b0b0b",
  "azure-blue": "#007fff",
  "azure-blue-oxford-navy": "#14213d",
  "azureblue": "#007fff",
  "baby-blue": "#89cff0",
  "baby-pink": "#ffb6c1",
  "baby-pink-arctic-white": "#ffffff",
  "babyblue": "#89cff0",
  "babypink": "#ffb6c1",
  "back-neon-yellow": "#ccff00",
  "ballad-blue": "#6baed6",
  "balladblue": "#6baed6",
  "baltic-blue": "#1d4ed8",
  "bark": "#71543e",
  "bear-brown": "#6b4f3a",
  "bearbrown": "#6b4f3a",
  "beige": "#e7d8bd",
  "beige-green": "#047857",
  "beige-orange": "#f97316",
  "beige-oxford": "#b8b8b8",
  "berry": "#8b1e3f",
  "beryl-blue": "#1d4ed8",
  "biking-red": "#d71920",
  "bikingred": "#d71920",
  "biscuit": "#d6b98c",
  "biscuit-almond": "#eed9c4",
  "biscuit-black": "#0b0b0b",
  "bkr": "#0b0b0b",
  "black": "#0b0b0b",
  "black-amber-white": "#ffffff",
  "black-anthracite": "#25282a",
  "black-anthracite-reflective-silver": "#c0c0c0",
  "black-ash": "#b2beb5",
  "black-azure": "#007fff",
  "black-azure-blue": "#007fff",
  "black-black": "#0b0b0b",
  "black-black-anthracite": "#25282a",
  "black-black-black": "#0b0b0b",
  "black-black-black-brushed-silver": "#c0c0c0",
  "black-black-black-white": "#ffffff",
  "black-black-melange": "#2f2f2f",
  "black-black-metallic-silver": "#c0c0c0",
  "black-black-slate-melange": "#8f8f8f",
  "black-black-white": "#ffffff",
  "black-blue": "#1d4ed8",
  "black-briar": "#5c4033",
  "black-bright-red": "#ff0000",
  "black-bright-royal": "#1d4ed8",
  "black-brown": "#6b4f3a",
  "black-burgundy": "#6f1d3b",
  "black-burnt-lime": "#a3a600",
  "black-camo": "#2f3437",
  "black-carbon-grey": "#4b5563",
  "black-charcoal": "#3f3f46",
  "black-check": "#999999",
  "black-cherry": "#de3163",
  "black-classic-red": "#d71920",
  "black-classic-red-white": "#ffffff",
  "black-dark-graphite": "#2f3437",
  "black-dark-grey": "#2f3437",
  "black-dark-lime": "#a3e635",
  "black-dark-olive": "#3f4133",
  "black-denim": "#243b64",
  "black-dolphin": "#6b7280",
  "black-dolphin-heather": "#9ca3af",
  "black-ebony": "#111111",
  "black-electric": "#0b0b0b",
  "black-emerald": "#50c878",
  "black-fire-red": "#e11d48",
  "black-fire-red-green": "#047857",
  "black-floral-mint": "#98ff98",
  "black-floral-red": "#ef1b1b",
  "black-flourescent-lime": "#ccff00",
  "black-fluorescent-orange": "#ff6700",
  "black-fluorescent-yellow": "#ccff00",
  "black-fuchia": "#ff00ff",
  "black-fuchsia": "#ff00ff",
  "black-gold": "#d4af37",
  "black-gold-white": "#ffffff",
  "black-granite": "#6b7280",
  "black-graphite": "#2f3437",
  "black-graphite-azureblue": "#007fff",
  "black-graphite-black": "#0b0b0b",
  "black-graphite-bright-red": "#ff0000",
  "black-graphite-classic-red": "#d71920",
  "black-graphite-grey": "#2f3437",
  "black-graphite-grey-white": "#ffffff",
  "black-graphite-white": "#ffffff",
  "black-green": "#047857",
  "black-green-camo": "#5f6f52",
  "black-grey": "#737373",
  "black-grey-camo": "#6b7280",
  "black-grey-marl": "#9ca3af",
  "black-grey-melange": "#4a4a4a",
  "black-grey-orange": "#f97316",
  "black-grey-white": "#ffffff",
  "black-gun-metal-grey-white": "#ffffff",
  "black-gunmetal": "#2a3439",
  "black-gunmetal-grey": "#737373",
  "black-heather": "#9ca3af",
  "black-heather-grey": "#9ca3af",
  "black-hi-vis": "#0b0b0b",
  "black-hi-vis-orange": "#ff5f00",
  "black-hi-vis-yellow": "#eaff00",
  "black-hot-pink": "#ff69b4",
  "black-ink": "#111827",
  "black-ink-heather": "#9ca3af",
  "black-jacks": "#0b0b0b",
  "black-kelly-green-white": "#ffffff",
  "black-light-graphite": "#2f3437",
  "black-light-grey": "#d1d5db",
  "black-light-grey-green": "#047857",
  "black-light-grey-red": "#ef1b1b",
  "black-light-grey-soft-white": "#f7f3ea",
  "black-light-grey-white": "#ffffff",
  "black-lightning-green": "#39ff14",
  "black-lime": "#a3e635",
  "black-lime-green": "#a3e635",
  "black-lime-white": "#ffffff",
  "black-loden": "#4b5320",
  "black-magma": "#cc5500",
  "black-marine-blue": "#123c69",
  "black-marl": "#9ca3af",
  "black-melange": "#2f2f2f",
  "black-melange-black": "#2f2f2f",
  "black-metallic-gold": "#d4af37",
  "black-mineral": "#111111",
  "black-mineral-grey": "#6f7673",
  "black-multicam": "#222222",
  "black-natural": "#e8dcc2",
  "black-navy": "#14213d",
  "black-neon-orange": "#ff7900",
  "black-neon-pink": "#ff1493",
  "black-new-royal": "#1d4ed8",
  "black-olive": "#2f3424",
  "black-onyx": "#111111",
  "black-orange": "#f97316",
  "black-orange-pop": "#f97316",
  "black-orange-white": "#ffffff",
  "black-oxford": "#b8b8b8",
  "black-oxford-grey": "#b8b8b8",
  "black-paisley": "#999999",
  "black-pink": "#ec4899",
  "black-pure": "#0b0b0b",
  "black-purple": "#5b21b6",
  "black-purple-white": "#ffffff",
  "black-raw": "#0b0b0b",
  "black-red": "#ef1b1b",
  "black-red-black": "#0b0b0b",
  "black-red-gold": "#d4af37",
  "black-red-red": "#ef1b1b",
  "black-red-white": "#ffffff",
  "black-reflective": "#c0c0c0",
  "black-reflective-silver": "#c0c0c0",
  "black-reflex": "#0b0b0b",
  "black-rock": "#111111",
  "black-rose": "#f43f5e",
  "black-royal": "#1d4ed8",
  "black-royal-white": "#ffffff",
  "black-seal": "#4b5563",
  "black-seal-grey": "#4b5563",
  "black-sealgrey": "#4b5563",
  "black-short-leg": "#0b0b0b",
  "black-silver": "#c0c0c0",
  "black-sky": "#87ceeb",
  "black-slate-melange": "#8f8f8f",
  "black-smoke": "#6b7280",
  "black-soft-white": "#f7f3ea",
  "black-stone": "#d6d3d1",
  "black-submarine-yellow": "#f4ff15",
  "black-sun-yellow-white": "#ffffff",
  "black-sunflower": "#ffda03",
  "black-surf-blue": "#38bdf8",
  "black-tan": "#d2b48c",
  "black-tan-denim": "#243b64",
  "black-teal": "#0f766e",
  "black-true-red": "#d71920",
  "black-turquoise": "#40e0d0",
  "black-urban-marl": "#9ca3af",
  "black-washed": "#0b0b0b",
  "black-white": "#ffffff",
  "black-white-black": "#0b0b0b",
  "black-white-cow": "#0b0b0b",
  "black-white-red": "#ef1b1b",
  "black-white-smoke-grey": "#737373",
  "black-white-tipping": "#0b0b0b",
  "black-white-white": "#ffffff",
  "black-yellow": "#f4ff15",
  "black-zoom-grey": "#8e9397",
  "blackberry": "#2b102f",
  "blackcamo": "#2f3437",
  "blackemerald": "#043927",
  "blackgold": "#5a4700",
  "blackgunmetal-grey": "#737373",
  "blackink": "#111827",
  "blackmelange": "#2f2f2f",
  "blackmineral": "#111111",
  "blackmulticam": "#222222",
  "blackolive": "#2f3424",
  "blackonyx": "#111111",
  "blackred": "#4a0000",
  "blackrock": "#111111",
  "blackwhite": "#737373",
  "blaze": "#ff5f00",
  "blaze-melange": "#f97316",
  "blaze-orange": "#ff5f00",
  "blazemelange": "#f97316",
  "blazeorange": "#ff5f00",
  "blazing-blue": "#1d4ed8",
  "blizzard-pink": "#ec4899",
  "blood-orange": "#cc5500",
  "bloodorange": "#cc5500",
  "blue": "#1d4ed8",
  "blue-bear": "#1d4ed8",
  "blue-beige": "#e7d8bd",
  "blue-black": "#0b0b0b",
  "blue-bunny": "#1d4ed8",
  "blue-check": "#999999",
  "blue-cloud": "#1d4ed8",
  "blue-denim": "#243b64",
  "blue-dragon": "#1d4ed8",
  "blue-dusk": "#314158",
  "blue-fog": "#b7c9d6",
  "blue-gray": "#6f8fa3",
  "blue-green": "#047857",
  "blue-grey": "#6f8fa3",
  "blue-heaven": "#89cff0",
  "blue-hero-bear": "#1d4ed8",
  "blue-ice": "#d8efff",
  "blue-jean": "#5d7fa3",
  "blue-marl": "#5d7fa3",
  "blue-melange": "#315c8c",
  "blue-mirror": "#1d4ed8",
  "blue-orange": "#f97316",
  "blue-oxford": "#b8b8b8",
  "blue-pacific": "#1ca9c9",
  "blue-pink": "#ec4899",
  "blue-raw": "#1d4ed8",
  "blue-soul": "#1d4ed8",
  "blue-steel": "#4682b4",
  "blue-stripe": "#999999",
  "blue-teddy": "#1d4ed8",
  "blue-tones": "#1d4ed8",
  "blue-topaz": "#1ca9c9",
  "blue-triblend": "#1d4ed8",
  "blue-white": "#ffffff",
  "blue-white-red": "#ef1b1b",
  "blue-wing": "#2f5d8c",
  "blue-yellow": "#f4ff15",
  "blueberry-cheescake": "#6baed6",
  "blueberry-swirl": "#314158",
  "bluedenim": "#243b64",
  "bluedusk": "#314158",
  "bluefog": "#b7c9d6",
  "bluegray": "#6f8fa3",
  "bluegrey": "#6f8fa3",
  "blueheaven": "#89cff0",
  "blueice": "#d8efff",
  "bluejean": "#5d7fa3",
  "bluemarl": "#5d7fa3",
  "bluemelange": "#315c8c",
  "bluemint": "#40e0d0",
  "bluepacific": "#1ca9c9",
  "bluesteel": "#4682b4",
  "bluetooth": "#1d4ed8",
  "bluetopaz": "#1ca9c9",
  "bluewing": "#2f5d8c",
  "blush": "#de5d83",
  "blush-blue": "#1d4ed8",
  "blush-mint": "#98ff98",
  "blush-pink": "#de5d83",
  "blush-pink-glow-in-the-dark": "#de5d83",
  "blushpink": "#de5d83",
  "bold-red": "#d71920",
  "bold-red-black": "#0b0b0b",
  "boldred": "#d71920",
  "bordeaux": "#5c0120",
  "bottle": "#047857",
  "bottle-beige": "#e7d8bd",
  "bottle-black": "#0b0b0b",
  "bottle-black-white": "#ffffff",
  "bottle-bottle": "#047857",
  "bottle-green": "#047857",
  "bottle-green-black": "#0b0b0b",
  "bottle-green-bottle-green": "#047857",
  "bottle-green-natural": "#e8dcc2",
  "bottle-green-off-white": "#f8f4e8",
  "bottle-green-seal-grey": "#4b5563",
  "bottle-green-white": "#ffffff",
  "bottle-green-white-snowflakes": "#047857",
  "bottle-white": "#ffffff",
  "bottle-white-snowflakes": "#047857",
  "bottlegreen": "#047857",
  "bottlewhite": "#047857",
  "briar": "#5c4033",
  "briar-black": "#0b0b0b",
  "briar-brown": "#5c4033",
  "briar-lime": "#a3e635",
  "briar-oxford": "#b8b8b8",
  "briarbrown": "#5c4033",
  "brick": "#9c3b2f",
  "brick-red": "#9c3b2f",
  "brickred": "#9c3b2f",
  "bright-blue": "#0074d9",
  "bright-cerise": "#de3163",
  "bright-green": "#00a651",
  "bright-lavender": "#b57edc",
  "bright-lilac": "#c8a2c8",
  "bright-navy": "#14213d",
  "bright-navy-marl": "#314158",
  "bright-ocean": "#005f8f",
  "bright-orange": "#ff7900",
  "bright-orange-black": "#0b0b0b",
  "bright-orange-marl": "#9ca3af",
  "bright-pink": "#ff69b4",
  "bright-purple-blue-melange": "#315c8c",
  "bright-red": "#ff0000",
  "bright-red-off-white": "#f8f4e8",
  "bright-royal": "#1d4ed8",
  "bright-royal-black-white": "#ffffff",
  "bright-royal-bright-royal": "#1d4ed8",
  "bright-royal-french-navy-white": "#ffffff",
  "bright-royal-off-white": "#f8f4e8",
  "bright-royal-white": "#ffffff",
  "bright-salmon": "#fa8072",
  "bright-sky": "#87ceeb",
  "bright-white": "#ffffff",
  "bright-yellow": "#f4ff15",
  "brightblue": "#0074d9",
  "brightgreen": "#00a651",
  "brightlilac": "#c8a2c8",
  "brightorange": "#ff7900",
  "brightpink": "#ff69b4",
  "brightred": "#ff0000",
  "brightroyal": "#1d4ed8",
  "brightsky": "#87ceeb",
  "brightwhite": "#ffffff",
  "brightyellow": "#f4ff15",
  "british-khaki": "#8a865d",
  "britishkhaki": "#8a865d",
  "bronze": "#cd7f32",
  "brother": "#1d4ed8",
  "brown": "#6b4f3a",
  "brown-bear": "#6b4f3a",
  "brown-beige": "#e7d8bd",
  "brown-black": "#0b0b0b",
  "brown-brown": "#6b4f3a",
  "brown-check": "#999999",
  "brown-dog": "#6b4f3a",
  "brown-khaki": "#8a865d",
  "brown-light": "#6b4f3a",
  "brown-savana": "#6b4f3a",
  "brown-sloth": "#6b4f3a",
  "brown-teddy": "#6b4f3a",
  "brown-white-brown": "#6b4f3a",
  "brushed-steel": "#8b9299",
  "brushedsteel": "#8b9299",
  "brut-denim": "#243b64",
  "bubble-gum-pink": "#ff69b4",
  "bubble-pink": "#ff69b4",
  "bubblegumpink": "#ff69b4",
  "bubblepink": "#ff69b4",
  "buck": "#8b5a2b",
  "buck-white": "#ffffff",
  "bunny-grey": "#737373",
  "bunny-key-ring-grey": "#737373",
  "bunny-light-brown": "#a67c52",
  "bunny-white": "#ffffff",
  "burgundy": "#6f1d3b",
  "burgundy-black": "#0b0b0b",
  "burgundy-burgundy": "#6f1d3b",
  "burgundy-camel": "#c19a6b",
  "burgundy-charcoal": "#3f3f46",
  "burgundy-gold": "#d4af37",
  "burgundy-heather-grey": "#9ca3af",
  "burgundy-light-grey": "#d1d5db",
  "burgundy-natural": "#e8dcc2",
  "burgundy-off-white": "#f8f4e8",
  "burgundy-sand": "#e7d8bd",
  "burgundy-sky": "#87ceeb",
  "burgundy-white": "#ffffff",
  "burnt-lime": "#a3a600",
  "burnt-olive": "#6b6a4a",
  "burnt-orange": "#cc5500",
  "burntlime": "#a3a600",
  "burntolive": "#6b6a4a",
  "burntorange": "#cc5500",
  "butter": "#fff1a8",
  "caffe-latte": "#c8a99a",
  "caffelatte": "#c8a99a",
  "camel": "#c19a6b",
  "camo": "#5f6f52",
  "camo-gray": "#6b7280",
  "camo-green": "#5f6f52",
  "camo-grey": "#6b7280",
  "camo-tree": "#5f6f52",
  "camogray": "#6b7280",
  "camogreen": "#5f6f52",
  "camogrey": "#6b7280",
  "camouflage": "#5f6f52",
  "canary": "#fff44f",
  "candy": "#ff7eb9",
  "candy-floss": "#ffb6c1",
  "candy-floss-pinks": "#ffb6c1",
  "candy-pink": "#ff7eb9",
  "candyfloss": "#ffb6c1",
  "candyfloss-pink": "#ffb6c1",
  "candyfloss-pink-white": "#ffffff",
  "candyflosspink": "#ffb6c1",
  "candypink": "#ff7eb9",
  "canvas-red": "#d71920",
  "canvasred": "#d71920",
  "canyon-pink": "#ec4899",
  "canyon-rust": "#b7410e",
  "canyonrust": "#b7410e",
  "cappucino": "#c8a99a",
  "caramel": "#c68e17",
  "caramel-black": "#0b0b0b",
  "carbon": "#4b5563",
  "carbon-grey": "#4b5563",
  "carbon-grey-black": "#0b0b0b",
  "carbon-heather": "#9ca3af",
  "carbon-heather-black": "#9ca3af",
  "carbongrey": "#4b5563",
  "cardinal": "#c41e3a",
  "cardinal-red": "#c41e3a",
  "cardinalred": "#c41e3a",
  "caribbean-blue": "#0077be",
  "caribbean-blues": "#1d4ed8",
  "caribbeanblue": "#0077be",
  "carolina-blue": "#89cff0",
  "carolinablue": "#89cff0",
  "castelrock": "#6b7280",
  "castle-rock-grey": "#6b7280",
  "castle-rock-light-heather": "#9ca3af",
  "castlerock-light-heather-white": "#9ca3af",
  "cat-black-white": "#ffffff",
  "caviar": "#111111",
  "cblue-white-cblue": "#ffffff",
  "cedar-green": "#3f4a3c",
  "cedargreen": "#3f4a3c",
  "celtic-green": "#00843d",
  "celticgreen": "#00843d",
  "cement": "#b7b1a8",
  "cement-gray": "#b7b1a8",
  "cement-grey": "#b7b1a8",
  "cementgray": "#b7b1a8",
  "cementgrey": "#b7b1a8",
  "chambray": "#7aa7c7",
  "charcoal": "#3f3f46",
  "charcoal-black": "#0b0b0b",
  "charcoal-black-melange": "#2f2f2f",
  "charcoal-black-triblend": "#3f3f46",
  "charcoal-grey-melange": "#4a4a4a",
  "charcoal-heather": "#3f3f46",
  "charcoal-heather-anthracite-white": "#3f3f46",
  "charcoal-heather-grey": "#3f3f46",
  "charcoal-herringbone": "#999999",
  "charcoal-hot-pink": "#ff69b4",
  "charcoal-jet-black": "#050505",
  "charcoal-lime": "#a3e635",
  "charcoal-lime-green": "#a3e635",
  "charcoal-lime-white": "#ffffff",
  "charcoal-marl": "#3f3f46",
  "charcoal-marl-marl-effect": "#3f3f46",
  "charcoal-melange": "#3f3f46",
  "charcoal-melange-black": "#3f3f46",
  "charcoal-navy": "#14213d",
  "charcoal-neon-green": "#39ff14",
  "charcoal-neon-orange": "#ff7900",
  "charcoal-orange": "#f97316",
  "charcoal-solid": "#3f3f46",
  "charcoal-stripe": "#999999",
  "charcoal-twill": "#3f3f46",
  "charcoal-white": "#ffffff",
  "charcoalheather": "#3f3f46",
  "charcoalmarl": "#3f3f46",
  "charcoalmelange": "#3f3f46",
  "check": "#999999",
  "checked": "#999999",
  "cheescake": "#6baed6",
  "cherry": "#de3163",
  "cherry-red": "#de3163",
  "cherry-sherbert": "#de3163",
  "cherry-white": "#ffffff",
  "cherryred": "#de3163",
  "chestnut": "#954535",
  "chili": "#b91c1c",
  "chilli": "#b91c1c",
  "chilli-blues": "#b91c1c",
  "chilli-red": "#b91c1c",
  "chillired": "#b91c1c",
  "china-blue": "#5d8aa8",
  "chinablue": "#5d8aa8",
  "chive-cypress": "#3f4a3c",
  "chocolate": "#7b3f00",
  "chocolate-brown": "#7b3f00",
  "chocolate-caramel": "#c68e17",
  "chocolate-chip": "#7b3f00",
  "chocolate-chip-greyish-brown": "#6b4f3a",
  "chocolate-dark-amber": "#ffbf00",
  "chocolatebrown": "#7b3f00",
  "christmas-deer": "#6b4f3a",
  "christmas-red": "#ef1b1b",
  "chrome": "#b6b6b6",
  "citrus": "#f4ff15",
  "city-red": "#d71920",
  "cityred": "#d71920",
  "cl-blue": "#0057b8",
  "claret": "#7f1734",
  "claret-red": "#7f1734",
  "claretred": "#7f1734",
  "classic-blue": "#1d4ed8",
  "classic-blue-heather": "#9ca3af",
  "classic-gray": "#737373",
  "classic-green": "#047857",
  "classic-green-white": "#ffffff",
  "classic-grey": "#737373",
  "classic-marl": "#9ca3af",
  "classic-navy": "#14213d",
  "classic-olive": "#4b5320",
  "classic-pink": "#ec4899",
  "classic-pink-graphite": "#2f3437",
  "classic-pink-graphite-grey": "#2f3437",
  "classic-pink-graphite-whi": "#2f3437",
  "classic-pink-light-grey": "#d1d5db",
  "classic-pink-white": "#ffffff",
  "classic-red": "#d71920",
  "classic-red-black": "#0b0b0b",
  "classic-red-black-white": "#ffffff",
  "classic-red-classic-red": "#d71920",
  "classic-red-navy": "#14213d",
  "classic-red-off-white": "#f8f4e8",
  "classic-red-seal-grey": "#4b5563",
  "classic-red-true-pink": "#ff69b4",
  "classic-red-white": "#ffffff",
  "classicblue": "#1d4ed8",
  "classicgray": "#737373",
  "classicgrey": "#737373",
  "classicnavy": "#14213d",
  "classicred": "#d71920",
  "clay": "#b66a50",
  "clay-black": "#0b0b0b",
  "clblue": "#0057b8",
  "clear": "#f8fafc",
  "clear-black": "#0b0b0b",
  "clear-blue": "#bdefff",
  "clear-green": "#047857",
  "clear-orange": "#f97316",
  "clear-orange-hi-vis": "#f97316",
  "clear-sky": "#bdefff",
  "clearblue": "#bdefff",
  "clearsky": "#bdefff",
  "cloud-grey": "#d1d5db",
  "cloud-heather": "#cbd5e1",
  "cloud-pink": "#ec4899",
  "cloudgrey": "#d1d5db",
  "cloudheather": "#cbd5e1",
  "cloudy-grey": "#a7adb4",
  "cloudy-haze": "#d1d5db",
  "cloudygrey": "#a7adb4",
  "club-cobalt": "#0047ab",
  "clubcobalt": "#0047ab",
  "cobalt": "#0047ab",
  "cobalt-blue": "#0047ab",
  "cobalt-blue-black": "#0b0b0b",
  "cobalt-blue-evening-blue": "#1d4ed8",
  "cobalt-melange": "#0047ab",
  "cobalt-navy": "#14213d",
  "cobaltblue": "#0047ab",
  "cobaltmelange": "#0047ab",
  "cocoa": "#7b3f00",
  "coffee": "#6f4e37",
  "coffee-brown": "#6f4e37",
  "coffeebrown": "#6f4e37",
  "colbalt-blue": "#0047ab",
  "college-green": "#007a3d",
  "college-navy": "#14213d",
  "college-navy-black-white": "#ffffff",
  "college-navy-white": "#ffffff",
  "collegegreen": "#007a3d",
  "collegenavy": "#14213d",
  "collegiate-navy": "#14213d",
  "collegiate-red": "#ef1b1b",
  "collegiate-royal": "#1d4ed8",
  "collegiatenavy": "#14213d",
  "collegiateroyal": "#1d4ed8",
  "combat": "#555c45",
  "combat-camo": "#555c45",
  "combat-green": "#555c45",
  "combatcamo": "#555c45",
  "combatgreen": "#555c45",
  "concrete": "#b7b1a8",
  "concrete-gray": "#b7b1a8",
  "concrete-grey": "#b7b1a8",
  "concretegray": "#b7b1a8",
  "concretegrey": "#b7b1a8",
  "convoy-grey": "#6b7280",
  "convoygrey": "#6b7280",
  "cookiesandcream": "#e8dcc2",
  "cool-grey": "#8b9095",
  "cool-grey-melange": "#4a4a4a",
  "cool-heather-grey": "#c5c7c9",
  "cool-silver": "#c0c0c0",
  "coolgrey": "#8b9095",
  "coolheathergrey": "#c5c7c9",
  "coolsilver": "#c0c0c0",
  "copper": "#b87333",
  "coral": "#ff7f50",
  "coral-silk": "#ff8f7f",
  "coralsilk": "#ff8f7f",
  "cornflower-blue": "#6495ed",
  "cornflowerblue": "#6495ed",
  "cornsilk": "#fff8dc",
  "corporate-blue": "#0057b8",
  "corporateblue": "#0057b8",
  "cosmic-fuchsia": "#ff00ff",
  "cosmic-fuchsia-white": "#ffffff",
  "cosmicfuchsia": "#ff00ff",
  "cosmo-pink": "#ff69b4",
  "cosmopink": "#ff69b4",
  "cotton-pink": "#ffb6c1",
  "cottonpink": "#ffb6c1",
  "covert-green": "#047857",
  "coyote": "#81613c",
  "coyote-brown": "#81613c",
  "coyote-brown-black": "#0b0b0b",
  "coyotebrown": "#81613c",
  "crackling-campfire": "#cc5500",
  "craft-green": "#4f7942",
  "craftgreen": "#4f7942",
  "cranberry": "#9f1239",
  "cranberry-marl": "#9f1239",
  "cranberry-red": "#9f1239",
  "cranberrymarl": "#9f1239",
  "cranberryred": "#9f1239",
  "cream": "#f5f0dc",
  "cream-bunny": "#f5f0dc",
  "cream-heather-grey": "#9ca3af",
  "cream-heather-pink": "#9ca3af",
  "cream-lamb": "#f5f0dc",
  "crimson": "#dc143c",
  "croissant": "#d6b98c",
  "crush-orange": "#ff7900",
  "crushorange": "#ff7900",
  "curry": "#d4a017",
  "cyan": "#00bcd4",
  "daisy": "#fff44f",
  "dark-aegean-blue": "#1d4ed8",
  "dark-beige": "#c8b99a",
  "dark-beige-camo": "#5f6f52",
  "dark-blue": "#1d4ed8",
  "dark-blue-denim": "#243b64",
  "dark-blue-wash": "#1d4ed8",
  "dark-brown": "#4b2e20",
  "dark-brown-wise-owl": "#4b2e20",
  "dark-camo": "#5f6f52",
  "dark-camo-black": "#0b0b0b",
  "dark-cedar-green": "#2f3a2f",
  "dark-cherry": "#de3163",
  "dark-chocolate": "#4b2e20",
  "dark-cobal-lobl": "#0047ab",
  "dark-denim": "#1f2f4a",
  "dark-emerald": "#50c878",
  "dark-forest": "#228b22",
  "dark-graphite": "#2f3437",
  "dark-gray": "#2f3437",
  "dark-green": "#064e3b",
  "dark-green-dark-green": "#064e3b",
  "dark-grey": "#2f3437",
  "dark-grey-black": "#0b0b0b",
  "dark-grey-black-off-white": "#f8f4e8",
  "dark-grey-dark-grey": "#2f3437",
  "dark-grey-heather": "#555555",
  "dark-grey-heather-matte-silver-white": "#555555",
  "dark-grey-marl": "#9ca3af",
  "dark-grey-melange": "#4a4a4a",
  "dark-grey-off-white": "#f8f4e8",
  "dark-grey-white": "#ffffff",
  "dark-grey-white-dark-grey": "#2f3437",
  "dark-heather": "#9ca3af",
  "dark-heather-blue": "#9ca3af",
  "dark-heather-grey": "#555555",
  "dark-khaki": "#6b6a4a",
  "dark-khaki-black": "#0b0b0b",
  "dark-khaki-storm-grey": "#4b5563",
  "dark-leaf-green": "#2f4f2f",
  "dark-melange": "#3f3f46",
  "dark-mocca": "#4b2e20",
  "dark-navy": "#071a33",
  "dark-navy-black": "#0b0b0b",
  "dark-navy-dark-navy": "#071a33",
  "dark-navy-heather": "#314158",
  "dark-navy-navy": "#14213d",
  "dark-olive": "#3f4133",
  "dark-orange": "#cc5500",
  "dark-pink": "#ec4899",
  "dark-plum": "#3d0734",
  "dark-purple": "#4c1d95",
  "dark-red": "#ef1b1b",
  "dark-royal": "#1e40af",
  "dark-royal-blue-black": "#0b0b0b",
  "dark-shadow": "#4b5563",
  "dark-shadow-dark-shadow": "#4b5563",
  "dark-smoke-grey-white": "#ffffff",
  "dark-spruce": "#0f3d2e",
  "dark-spruce-black": "#0b0b0b",
  "dark-taupe": "#6f696d",
  "darkbeige": "#c8b99a",
  "darkbrown": "#4b2e20",
  "darkcedargreen": "#2f3a2f",
  "darkchocolate": "#4b2e20",
  "darkdenim": "#1f2f4a",
  "darkgray": "#2f3437",
  "darkgreen": "#064e3b",
  "darkgrey": "#2f3437",
  "darkgreyheather": "#555555",
  "darkheathergrey": "#555555",
  "darkkhaki": "#6b6a4a",
  "darkleafgreen": "#2f4f2f",
  "darkmelange": "#3f3f46",
  "darkmocca": "#4b2e20",
  "darknavy": "#071a33",
  "darkolive": "#3f4133",
  "darkorange": "#cc5500",
  "darkplum": "#3d0734",
  "darkpurple": "#4c1d95",
  "darkroyal": "#1e40af",
  "darkspruce": "#0f3d2e",
  "darktaupe": "#6f696d",
  "day-fall": "#c96f3d",
  "deep-black": "#050505",
  "deep-black-white": "#ffffff",
  "deep-blue": "#1d4ed8",
  "deep-burgundy": "#6f1d3b",
  "deep-forest": "#142d14",
  "deep-green": "#064e3b",
  "deep-green-black": "#0b0b0b",
  "deep-grey": "#4b5563",
  "deep-grey-black": "#0b0b0b",
  "deep-grey-fiery-orange": "#ff7900",
  "deep-grey-heather": "#6b7280",
  "deep-heather": "#9ca3af",
  "deep-khaki": "#8a865d",
  "deep-navy": "#071a33",
  "deep-olive": "#3f4133",
  "deep-purple": "#4c1d95",
  "deep-red": "#ef1b1b",
  "deep-red-black": "#0b0b0b",
  "deep-royal": "#1e40af",
  "deep-spruce": "#0f3d2e",
  "deep-sun": "#ffcc00",
  "deep-teal": "#0f766e",
  "deep-wine": "#5f1630",
  "deep-yellow": "#f4ff15",
  "deepblack": "#050505",
  "deepforest": "#142d14",
  "deepgreen": "#064e3b",
  "deepgrey": "#4b5563",
  "deepgreyheather": "#6b7280",
  "deepnavy": "#071a33",
  "deepolive": "#3f4133",
  "deeppurple": "#4c1d95",
  "deeproyal": "#1e40af",
  "deepspruce": "#0f3d2e",
  "deepsun": "#ffcc00",
  "deepwine": "#5f1630",
  "denim": "#243b64",
  "denim-blue": "#243b64",
  "denim-marl": "#9ca3af",
  "denim-melange": "#315c8c",
  "denimblue": "#243b64",
  "denimmelange": "#315c8c",
  "desert": "#c2b280",
  "desert-dust": "#c2b280",
  "desert-khaki": "#c2b280",
  "desert-peaks": "#c2b280",
  "desert-sand": "#c2b280",
  "desert-sand-black": "#0b0b0b",
  "desertdust": "#c2b280",
  "desertkhaki": "#c2b280",
  "desertsand": "#c2b280",
  "digital-lavender": "#b57edc",
  "digitallavender": "#b57edc",
  "dijon-blue": "#314158",
  "dijonblue": "#314158",
  "dip-dye-hydro": "#4cb7a5",
  "dip-dye-hydro-aloe": "#c7e6c5",
  "dip-dye-worker-blue-heather-grey": "#9ca3af",
  "dipdyehydro": "#4cb7a5",
  "diva-blue": "#1d4ed8",
  "dolphin": "#6b7280",
  "dolphin-black": "#0b0b0b",
  "dove-grey": "#b8b8b8",
  "dovegrey": "#b8b8b8",
  "downpour-grey": "#62666a",
  "downpourgrey": "#62666a",
  "driftwood": "#8b8589",
  "dtg-black": "#0b0b0b",
  "dtg-dark-grey": "#2f3437",
  "dtg-white": "#ffffff",
  "dtgblack": "#0b0b0b",
  "dtgwhite": "#ffffff",
  "duck-egg": "#c3e7e8",
  "dusk": "#6b7280",
  "dusk-midnight": "#061326",
  "dusk-rose": "#c08081",
  "duskrose": "#c08081",
  "dusky-blue": "#6b8ba4",
  "dusky-pink": "#d88ca1",
  "dusky-pink-off-white": "#f8f4e8",
  "duskyblue": "#6b8ba4",
  "duskypink": "#d88ca1",
  "dust": "#c8bfb1",
  "dust-orange": "#c96f3d",
  "dust-white-dust-brushed-silver": "#c0c0c0",
  "dustorange": "#c96f3d",
  "dusty-beige": "#e7d8bd",
  "dusty-blue": "#6b8ba4",
  "dusty-green": "#047857",
  "dusty-green-dip-dye": "#047857",
  "dusty-grey": "#737373",
  "dusty-orange": "#c96f3d",
  "dusty-pink": "#d88ca1",
  "dusty-purple": "#5b21b6",
  "dusty-red": "#ef1b1b",
  "dusty-rose": "#c08081",
  "dusty-turquoise": "#40e0d0",
  "dustyblue": "#6b8ba4",
  "dustyorange": "#c96f3d",
  "dustypink": "#d88ca1",
  "dustyrose": "#c08081",
  "earth": "#8a6f4d",
  "earth-tones": "#8a6f4d",
  "earthy-green": "#047857",
  "eau-de-nil-white": "#ffffff",
  "ebony": "#111111",
  "ebony-black": "#0b0b0b",
  "eco-grey": "#aaa",
  "eco-heather": "#9ca3af",
  "eco-raw": "#e8dcc2",
  "ecogrey": "#aaa",
  "ecru": "#f3ead7",
  "ecru-black": "#0b0b0b",
  "edge": "#6b7280",
  "eggplant": "#3d0734",
  "electric-blue": "#0074ff",
  "electric-green": "#00ff66",
  "electric-grey": "#737373",
  "electric-orange": "#ff7900",
  "electric-pink": "#ff1493",
  "electric-yellow": "#ccff00",
  "electric-yellow-black": "#0b0b0b",
  "electric-yellow-jet-black": "#050505",
  "electricblue": "#0074ff",
  "electricgreen": "#00ff66",
  "electricorange": "#ff7900",
  "electricpink": "#ff1493",
  "electricyellow": "#ccff00",
  "elephant-grey": "#767676",
  "elephantgrey": "#767676",
  "emerald": "#50c878",
  "emerald-green": "#047857",
  "emerald-soft-white": "#f7f3ea",
  "emerald-white": "#ffffff",
  "emeraldgreen": "#047857",
  "espresso-haze": "#4b2e20",
  "evergreen": "#064e3b",
  "evergreen-white": "#ffffff",
  "extreme-green": "#00ff66",
  "extreme-green-black": "#0b0b0b",
  "extremegreen": "#00ff66",
  "f-navy-classic-red-white": "#ffffff",
  "f-navy-f-navy-white": "#ffffff",
  "faded-floral": "#999999",
  "fadedfloral": "#999999",
  "fennel": "#8a9a5b",
  "fennel-pink": "#ec4899",
  "fern": "#4f7942",
  "fern-green": "#4f7942",
  "ferngreen": "#4f7942",
  "festival-fuchsia": "#ff00ff",
  "festivalfuchsia": "#ff00ff",
  "fiery-orange": "#ff7900",
  "fiery-orange-surf-blue": "#38bdf8",
  "fieryorange": "#ff7900",
  "fiesta": "#ff7900",
  "fig": "#4b1f3a",
  "fire": "#e11d48",
  "fire-red": "#e11d48",
  "fire-red-arctic-white": "#ffffff",
  "fire-red-black": "#0b0b0b",
  "fire-red-jet-black": "#050505",
  "fire-red-red": "#ef1b1b",
  "fire-red-white": "#ffffff",
  "firered": "#e11d48",
  "flag-red": "#d71920",
  "flagred": "#d71920",
  "flame": "#f97316",
  "flame-red": "#e11d48",
  "flamered": "#e11d48",
  "flesh": "#f2c6a0",
  "flint": "#bcc9d6",
  "flint-gray": "#bcc9d6",
  "flint-grey": "#bcc9d6",
  "flint-stone": "#bcc9d6",
  "flintgray": "#bcc9d6",
  "flintgrey": "#bcc9d6",
  "flintstone": "#bcc9d6",
  "flo-blue": "#1d4ed8",
  "flo-orange": "#ff7900",
  "flo-yellow": "#ccff00",
  "floorange": "#ff7900",
  "floral-mint": "#98ff98",
  "floral-red": "#ef1b1b",
  "floralmint": "#98ff98",
  "floralred": "#ef1b1b",
  "floro-green": "#00ff66",
  "floro-orange": "#ff7900",
  "floro-pink": "#ff1493",
  "floro-yellow": "#ccff00",
  "florogreen": "#00ff66",
  "floroorange": "#ff7900",
  "floropink": "#ff1493",
  "floroyellow": "#ccff00",
  "flourescent-lime": "#ccff00",
  "flourescent-orange": "#ff6700",
  "flourescent-yellow": "#ccff00",
  "flow-blaze": "#ff5f00",
  "floyellow": "#ccff00",
  "fluo-green": "#00ff66",
  "fluo-orange": "#ff7900",
  "fluo-pink": "#ff1493",
  "fluogreen": "#00ff66",
  "fluoorange": "#ff7900",
  "fluopink": "#ff1493",
  "fluor-yellow": "#ccff00",
  "fluor-yellow-fluor-orange-black": "#0b0b0b",
  "fluorescent-green": "#00ff66",
  "fluorescent-lime": "#ccff00",
  "fluorescent-orange": "#ff6700",
  "fluorescent-orange-black": "#0b0b0b",
  "fluorescent-orange-navy": "#14213d",
  "fluorescent-pink": "#ff1493",
  "fluorescent-red": "#ef1b1b",
  "fluorescent-yellow": "#ccff00",
  "fluorescent-yellow-black": "#0b0b0b",
  "fluorescent-yellow-fluorescent-orange-black": "#0b0b0b",
  "fluorescent-yellow-navy": "#14213d",
  "fluorescentgreen": "#00ff66",
  "fluorescentlime": "#ccff00",
  "fluorescentorange": "#ff6700",
  "fluorescentpink": "#ff1493",
  "fluorescentyellow": "#ccff00",
  "fluoro-orange": "#ff6700",
  "fluoro-yellow": "#ccff00",
  "fluoroorange": "#ff6700",
  "fluoroyellow": "#ccff00",
  "fluoryellow": "#ccff00",
  "fluro-pink": "#ff1493",
  "fluro-yellow": "#ccff00",
  "fluropink": "#ff1493",
  "fluroyellow": "#ccff00",
  "fog-blue": "#1d4ed8",
  "fog-green": "#047857",
  "forager-fusion": "#5f6f52",
  "forest": "#228b22",
  "forest-green": "#228b22",
  "forest-green-gold": "#d4af37",
  "forest-green-green": "#047857",
  "forest-green-taupe": "#8b8589",
  "forest-night": "#142d14",
  "forest-nights": "#142d14",
  "forest-putty": "#c8bfb1",
  "forestgreen": "#228b22",
  "forestnight": "#142d14",
  "forestnights": "#142d14",
  "forgotten-orange": "#cc5500",
  "forgottenorange": "#cc5500",
  "fraiche-peche": "#ffcba4",
  "french-blue-navy": "#14213d",
  "french-blue-seal-grey": "#4b5563",
  "french-dark-navy": "#071a33",
  "french-dark-navy-natural": "#e8dcc2",
  "french-navy": "#101f3d",
  "french-navy-arctic-white": "#ffffff",
  "french-navy-black": "#0b0b0b",
  "french-navy-black-white": "#ffffff",
  "french-navy-blue-melange": "#315c8c",
  "french-navy-bright-royal-white": "#ffffff",
  "french-navy-classic-red": "#d71920",
  "french-navy-classic-red-white": "#ffffff",
  "french-navy-fire-red": "#e11d48",
  "french-navy-french-navy": "#101f3d",
  "french-navy-heather": "#314158",
  "french-navy-light-grey": "#d1d5db",
  "french-navy-off-white": "#f8f4e8",
  "french-navy-orange-white": "#ffffff",
  "french-navy-putty": "#c8bfb1",
  "french-navy-royal": "#1d4ed8",
  "french-navy-sapphire-blue-white": "#ffffff",
  "french-navy-stone": "#d6d3d1",
  "french-navy-taupe": "#8b8589",
  "french-navy-white": "#ffffff",
  "frenchdarknavy": "#071a33",
  "frenchnavy": "#101f3d",
  "fresh-green": "#00a651",
  "fresh-green-black": "#0b0b0b",
  "fresh-pink": "#ec4899",
  "freshgreen": "#00a651",
  "frost-grey": "#b9bec7",
  "frost-grey-black": "#0b0b0b",
  "frost-grey-heather": "#9ca3af",
  "frostgrey": "#b9bec7",
  "fuchia": "#ff00ff",
  "fuchsia": "#ff00ff",
  "fuchsia-black": "#0b0b0b",
  "fuchsia-black-light-grey": "#d1d5db",
  "fuchsia-graphite": "#2f3437",
  "fuchsia-graphite-grey": "#2f3437",
  "fuchsia-heather-grey": "#9ca3af",
  "fuchsia-off-white": "#f8f4e8",
  "fuchsia-white": "#ffffff",
  "game-royal": "#1d4ed8",
  "game-royal-white": "#ffffff",
  "gameroyal": "#1d4ed8",
  "garden-green": "#3f8f3f",
  "gardengreen": "#3f8f3f",
  "garment-dye-black-rock": "#111111",
  "garment-dyed-aged-light-grey": "#d1d5db",
  "garment-dyed-black-rock": "#111111",
  "garment-dyed-blue-stone": "#d6d3d1",
  "garment-dyed-bubble-pink": "#ff69b4",
  "garment-dyed-hydro": "#4cb7a5",
  "garment-dyed-khaki": "#8a865d",
  "garment-dyed-latte": "#c8a99a",
  "garment-dyed-ochre": "#cc7722",
  "garment-dyed-swimmer-blue": "#1d4ed8",
  "garmentdyedblackrock": "#111111",
  "garnet": "#733635",
  "gas-safe-register-black": "#0b0b0b",
  "gas-safe-register-white": "#ffffff",
  "ginger": "#b86b33",
  "giraffe-brown": "#6b4f3a",
  "giraffebrown": "#6b4f3a",
  "glacier-grey": "#b9bec7",
  "glacier-peaks": "#d8efff",
  "glaciergrey": "#b9bec7",
  "glazed-green": "#00a651",
  "glazedgreen": "#00a651",
  "glowlight": "#ccff00",
  "go-green": "#00a651",
  "gogreen": "#00a651",
  "gold": "#d4af37",
  "gold-black": "#0b0b0b",
  "gold-white-beige": "#e7d8bd",
  "gold-yellow": "#d4af37",
  "golden": "#d4af37",
  "golden-pecan": "#b8860b",
  "golden-yellow": "#f4ff15",
  "goldenpecan": "#b8860b",
  "goldyellow": "#d4af37",
  "granite": "#6b7280",
  "granite-black": "#0b0b0b",
  "granite-heather": "#6b7280",
  "granite-marl": "#6b7280",
  "graniteheather": "#6b7280",
  "granitemarl": "#6b7280",
  "grape": "#6f2da8",
  "grape-purple": "#6f2da8",
  "grapepurple": "#6f2da8",
  "graphite": "#2f3437",
  "graphite-black": "#0b0b0b",
  "graphite-black-white": "#ffffff",
  "graphite-gray": "#2f3437",
  "graphite-grey": "#2f3437",
  "graphite-grey-black": "#0b0b0b",
  "graphite-grey-blush": "#de5d83",
  "graphite-grey-light-grey": "#d1d5db",
  "graphite-grey-oyster-grey": "#737373",
  "graphite-heather": "#9ca3af",
  "graphitegray": "#2f3437",
  "graphitegrey": "#2f3437",
  "grass-green": "#4cbb17",
  "grassgreen": "#4cbb17",
  "gray": "#737373",
  "gray-melange": "#4a4a4a",
  "graymelange": "#4a4a4a",
  "green": "#047857",
  "green-bay": "#047857",
  "green-beige": "#e7d8bd",
  "green-black": "#0b0b0b",
  "green-camo": "#5f6f52",
  "green-camo-black": "#0b0b0b",
  "green-check": "#999999",
  "green-christmas-tree": "#047857",
  "green-dinosaur": "#047857",
  "green-glow": "#047857",
  "green-gold-white": "#ffffff",
  "green-green": "#047857",
  "green-hi-vis-yellow": "#eaff00",
  "green-marl": "#9ca3af",
  "green-navy": "#14213d",
  "green-navy-check": "#999999",
  "green-silver": "#c0c0c0",
  "green-white": "#ffffff",
  "greencamo": "#5f6f52",
  "greenish-grey": "#737373",
  "grey": "#737373",
  "grey-asphalt": "#343434",
  "grey-black": "#0b0b0b",
  "grey-black-denim": "#243b64",
  "grey-black-white": "#ffffff",
  "grey-blue": "#1d4ed8",
  "grey-brown-check": "#999999",
  "grey-camo": "#6b7280",
  "grey-check": "#999999",
  "grey-cobalt": "#0047ab",
  "grey-denim": "#243b64",
  "grey-elephant": "#737373",
  "grey-fog": "#737373",
  "grey-glow-in-the-dark": "#737373",
  "grey-gold": "#d4af37",
  "grey-green": "#047857",
  "grey-grey": "#737373",
  "grey-grey-melange": "#4a4a4a",
  "grey-heather": "#9ca3af",
  "grey-khaki": "#8a865d",
  "grey-lime": "#a3e635",
  "grey-marl": "#9ca3af",
  "grey-marl-black": "#9ca3af",
  "grey-marl-grey": "#9ca3af",
  "grey-melange": "#4a4a4a",
  "grey-melange-black": "#2f2f2f",
  "grey-melange-tan": "#4a4a4a",
  "grey-orange": "#f97316",
  "grey-pink": "#ec4899",
  "grey-pink-marble": "#737373",
  "grey-red": "#ef1b1b",
  "grey-stripe": "#999999",
  "grey-three": "#737373",
  "grey-triblend": "#737373",
  "grey-white": "#ffffff",
  "grey-white-mesh": "#ffffff",
  "grey-white-penguin": "#ffffff",
  "grey-yellow": "#f4ff15",
  "greycamo": "#6b7280",
  "greyish-navy": "#374151",
  "greyishnavy": "#374151",
  "greymarl": "#9ca3af",
  "greymelange": "#4a4a4a",
  "griffin": "#6b7280",
  "griffin-grey": "#6b7280",
  "griffingrey": "#6b7280",
  "gun-metal": "#2a3439",
  "gunmetal": "#2a3439",
  "gunmetal-grey-black-black": "#0b0b0b",
  "gunmetal-grey-lime": "#a3e635",
  "halo-grey": "#b9bec7",
  "halogrey": "#b9bec7",
  "hamilton-blue": "#3b82f6",
  "hamiltonblue": "#3b82f6",
  "harbour-navy": "#14213d",
  "harbournavy": "#14213d",
  "hawaiian-blue": "#00a3e0",
  "hawaiian-blue-natural": "#e8dcc2",
  "hawaiian-ocean": "#00a3e0",
  "hawaiianblue": "#00a3e0",
  "hawaiianocean": "#00a3e0",
  "hazelnut": "#b8860b",
  "heather": "#9ca3af",
  "heather-amber": "#9ca3af",
  "heather-black": "#9ca3af",
  "heather-black-charcoal": "#9ca3af",
  "heather-blue": "#9ca3af",
  "heather-burgundy": "#9ca3af",
  "heather-cardinal": "#9ca3af",
  "heather-deep-teal": "#9ca3af",
  "heather-dust": "#9ca3af",
  "heather-green": "#9ca3af",
  "heather-grey": "#9ca3af",
  "heather-grey-black": "#9ca3af",
  "heather-grey-charcoal": "#9ca3af",
  "heather-grey-dark-grey": "#9ca3af",
  "heather-grey-deep-navy": "#9ca3af",
  "heather-grey-fire-red": "#9ca3af",
  "heather-grey-fleck": "#9ca3af",
  "heather-grey-fog": "#9ca3af",
  "heather-grey-french-navy": "#9ca3af",
  "heather-grey-jet-black": "#9ca3af",
  "heather-grey-melange": "#4a4a4a",
  "heather-grey-navy": "#9ca3af",
  "heather-grey-white": "#9ca3af",
  "heather-grey-white-stars": "#9ca3af",
  "heather-haze": "#9ca3af",
  "heather-heather": "#9ca3af",
  "heather-maroon": "#9ca3af",
  "heather-mauve": "#c8a2c8",
  "heather-mid-grey": "#9ca3af",
  "heather-military-green": "#9ca3af",
  "heather-mint": "#9ca3af",
  "heather-navy": "#9ca3af",
  "heather-oatmeal": "#9ca3af",
  "heather-olive": "#9ca3af",
  "heather-peach": "#9ca3af",
  "heather-prism-dusty-blue": "#9ca3af",
  "heather-prism-ice-blue": "#9ca3af",
  "heather-prism-lilac": "#9ca3af",
  "heather-prism-mint": "#9ca3af",
  "heather-prism-peach": "#9ca3af",
  "heather-prism-sunset": "#9ca3af",
  "heather-purple": "#9ca3af",
  "heather-rainbow": "#9ca3af",
  "heather-red": "#9ca3af",
  "heather-royal": "#9ca3af",
  "heather-sand": "#9ca3af",
  "heather-sapphire": "#9ca3af",
  "heather-slate": "#9ca3af",
  "heather-tarmac": "#9ca3af",
  "heather-white": "#9ca3af",
  "heathergrey": "#9ca3af",
  "heathermauve": "#c8a2c8",
  "heaven": "#89cff0",
  "heaven-blue": "#89cff0",
  "heavenblue": "#89cff0",
  "heliconia": "#ff1493",
  "helionia": "#ff1493",
  "heritage-brown": "#71543e",
  "heritagebrown": "#71543e",
  "herringbone": "#999999",
  "hi-vis-orange": "#ff5f00",
  "hi-vis-orange-black": "#0b0b0b",
  "hi-vis-orange-hi-vis-yellow": "#eaff00",
  "hi-vis-orange-mesh": "#ff5f00",
  "hi-vis-orange-navy": "#14213d",
  "hi-vis-orange-royal": "#1d4ed8",
  "hi-vis-yellow": "#eaff00",
  "hi-vis-yellow-black": "#0b0b0b",
  "hi-vis-yellow-green": "#047857",
  "hi-vis-yellow-grey": "#737373",
  "hi-vis-yellow-mesh": "#eaff00",
  "hi-vis-yellow-navy": "#14213d",
  "hi-vis-yellow-orange": "#f97316",
  "hi-vis-yellow-paramedic-green": "#00a651",
  "hi-vis-yellow-red": "#ef1b1b",
  "hi-vis-yellow-royal-blue": "#1d4ed8",
  "hi-viz-orange": "#ff5f00",
  "hi-viz-yellow": "#eaff00",
  "hibiscus-rose": "#f43f5e",
  "hibiscusrose": "#f43f5e",
  "hibiskus-pink": "#f43f5e",
  "hibiskuspink": "#f43f5e",
  "high-vis-orange": "#ff5f00",
  "high-vis-yellow": "#eaff00",
  "high-viz-orange": "#ff5f00",
  "high-viz-yellow": "#eaff00",
  "highland-cow": "#a67c52",
  "highlander": "#4b5320",
  "highvisorange": "#ff5f00",
  "highvisyellow": "#eaff00",
  "highvizorange": "#ff5f00",
  "highvizyellow": "#eaff00",
  "hivis-orange": "#ff5f00",
  "hivis-yellow": "#eaff00",
  "hivisorange": "#ff5f00",
  "hivisyellow": "#eaff00",
  "hivizorange": "#ff5f00",
  "hivizyellow": "#eaff00",
  "holly-green": "#0b5d35",
  "hollygreen": "#0b5d35",
  "holographic-rainbow": "#999999",
  "holographic-silver": "#c0c0c0",
  "holographicrainbow": "#999999",
  "holographicsilver": "#c0c0c0",
  "honey": "#d4a017",
  "honey-black": "#0b0b0b",
  "honey-white": "#ffffff",
  "horizon-blue": "#6baed6",
  "horizonblue": "#6baed6",
  "hospital-blue-white": "#ffffff",
  "hot-chocolate": "#5c4033",
  "hot-coral": "#ff7f50",
  "hot-orange": "#ff7900",
  "hot-orange-black": "#0b0b0b",
  "hot-pink": "#ff69b4",
  "hot-pink-black": "#0b0b0b",
  "hot-pink-french-navy": "#101f3d",
  "hot-pink-natural": "#e8dcc2",
  "hot-pink-white": "#ffffff",
  "hot-red": "#e11d48",
  "hot-red-natural": "#e8dcc2",
  "hotchocolate": "#5c4033",
  "hotcoral": "#ff7f50",
  "hotorange": "#ff7900",
  "hotpink": "#ff69b4",
  "hotred": "#e11d48",
  "houndstooth": "#999999",
  "hunter-green": "#064e3b",
  "huntergreen": "#064e3b",
  "hv-orange": "#ff5f00",
  "hv-orange-green": "#047857",
  "hv-orange-grey": "#737373",
  "hv-orange-navy": "#14213d",
  "hv-orange-royal": "#1d4ed8",
  "hv-red-grey": "#737373",
  "hv-yellow": "#eaff00",
  "hv-yellow-black": "#0b0b0b",
  "hv-yellow-bottle": "#047857",
  "hv-yellow-deep-sky-blue": "#87ceeb",
  "hv-yellow-grey": "#737373",
  "hv-yellow-navy": "#14213d",
  "hv-yellow-navy-print": "#999999",
  "hv-yellow-paramedic-green": "#00a651",
  "hv-yellow-purple": "#5b21b6",
  "hv-yellow-royal": "#1d4ed8",
  "hv-yellow-royal-blue": "#1d4ed8",
  "hv-yellowblack": "#eaff00",
  "hv-yellownavy": "#eaff00",
  "hv-yellowparamedic-green": "#047857",
  "hv-yellowroyal-blue": "#1d4ed8",
  "hvorange": "#ff5f00",
  "hvyellow": "#eaff00",
  "hvyellowparamedicgreen": "#00a651",
  "hyper-pink": "#ff1493",
  "hyperpink": "#ff1493",
  "ice-blue": "#d8efff",
  "ice-grey": "#dce3e8",
  "ice-mint": "#d0fff0",
  "ice-orange": "#ffb36b",
  "iceblue": "#d8efff",
  "icegrey": "#dce3e8",
  "icemint": "#d0fff0",
  "iceorange": "#ffb36b",
  "icy-grey": "#dce3e8",
  "icy-navy": "#172033",
  "icy-white": "#f7fbff",
  "icygrey": "#dce3e8",
  "icynavy": "#172033",
  "icywhite": "#f7fbff",
  "india-ink-grey": "#3f3f46",
  "indiainkgrey": "#3f3f46",
  "indigo": "#1e3a8a",
  "indigo-blue": "#1e3a8a",
  "indigo-blue-black": "#0b0b0b",
  "indigo-brown-denim": "#243b64",
  "indigo-denim": "#1e3a8a",
  "indigo-heather": "#344a78",
  "indigo-indigo-heather": "#344a78",
  "indigo-melange": "#344a78",
  "indigo-midnight": "#061326",
  "indigo-palm": "#344a78",
  "indigoblue": "#1e3a8a",
  "indigodenim": "#1e3a8a",
  "indigoheather": "#344a78",
  "indigomelange": "#344a78",
  "indigopalm": "#344a78",
  "ink": "#182033",
  "ink-blue": "#182033",
  "inkblue": "#182033",
  "intense-blue": "#0057b8",
  "intenseblue": "#0057b8",
  "iris": "#5b21b6",
  "irish-green": "#009e60",
  "irishgreen": "#009e60",
  "iron": "#4b5563",
  "iron-black": "#0b0b0b",
  "iron-grey": "#4b5563",
  "iron-grey-black-white": "#ffffff",
  "irongrey": "#4b5563",
  "italian-blue": "#007fff",
  "italianblue": "#007fff",
  "ivory": "#fffff0",
  "ivy-green": "#064e3b",
  "ivygreen": "#064e3b",
  "jade": "#00a86b",
  "jade-dome": "#00a86b",
  "jade-natural": "#e8dcc2",
  "jadedome": "#00a86b",
  "jet": "#050505",
  "jet-black": "#050505",
  "jet-black-arctic-white": "#ffffff",
  "jet-black-charcoal": "#3f3f46",
  "jet-black-electric-orange": "#ff7900",
  "jet-black-fire-red": "#e11d48",
  "jet-black-gold": "#d4af37",
  "jet-black-heather-grey": "#9ca3af",
  "jet-black-hot-pink": "#ff69b4",
  "jet-black-orange-crush": "#ff7900",
  "jet-black-sun-yellow": "#ffd700",
  "jet-black-white": "#ffffff",
  "jetblack": "#050505",
  "jungle-camo": "#4b5320",
  "jungle-camo-black": "#0b0b0b",
  "junglecamo": "#4b5320",
  "juniper-black": "#0b0b0b",
  "kaffa-coffee": "#6f4e37",
  "kaffacoffee": "#6f4e37",
  "kanati-camo-print": "#5f6f52",
  "kanaticamoprint": "#5f6f52",
  "kangaroo": "#a67c52",
  "kelly": "#4cbb17",
  "kelly-green": "#4cbb17",
  "kelly-green-arctic-white": "#ffffff",
  "kelly-green-black": "#0b0b0b",
  "kelly-green-off-white": "#f8f4e8",
  "kelly-green-white": "#ffffff",
  "kelly-mist": "#4cbb17",
  "kelly-white-kelly": "#4cbb17",
  "kellygreen": "#4cbb17",
  "key-lime": "#a3e635",
  "key-lime-seal-grey": "#4b5563",
  "key-ring-light-brown": "#a67c52",
  "keylime": "#a3e635",
  "khaki": "#8a865d",
  "khaki-black": "#0b0b0b",
  "khaki-black-mesh": "#0b0b0b",
  "khaki-brown": "#6b4f3a",
  "khaki-forest-green": "#228b22",
  "khaki-khaki": "#8a865d",
  "khaki-multicam": "#8a865d",
  "khaki-white": "#ffffff",
  "khaki-white-khaki": "#8a865d",
  "khakimulticam": "#8a865d",
  "kit": "#c8b99a",
  "kiwi": "#8db600",
  "koala-bear": "#737373",
  "koala-grey": "#737373",
  "lagoon-blue": "#4cb7a5",
  "lagoon-turquoise": "#4cb7a5",
  "lagoonblue": "#4cb7a5",
  "lagoonturquoise": "#4cb7a5",
  "lake-blue": "#4f8fbf",
  "lakeblue": "#4f8fbf",
  "latte": "#c8a99a",
  "lava-grey": "#565656",
  "lavagrey": "#565656",
  "lavender": "#b57edc",
  "lavender-fizz": "#b57edc",
  "lavender-french-navy": "#101f3d",
  "lavender-white": "#ffffff",
  "lavenderfizz": "#b57edc",
  "leaf": "#4f7942",
  "leaf-green": "#4f7942",
  "leafgreen": "#4f7942",
  "legend-ink": "#182033",
  "legendink": "#182033",
  "lemon": "#fff44f",
  "lemon-yellow": "#fff44f",
  "lemonyellow": "#fff44f",
  "lichen": "#8a9a5b",
  "light-asphalt": "#343434",
  "light-blue": "#a8d8f0",
  "light-blue-mid-blue-bright-navy": "#14213d",
  "light-blue-navy": "#14213d",
  "light-blue-wash": "#a8d8f0",
  "light-blue-white": "#ffffff",
  "light-brown": "#a67c52",
  "light-brown-bunny": "#a67c52",
  "light-brown-dog": "#a67c52",
  "light-brown-gingerbread-man": "#a67c52",
  "light-brown-pony": "#a67c52",
  "light-charcoal": "#3f3f46",
  "light-denim": "#5d7fa3",
  "light-gold": "#d4af37",
  "light-graphite": "#2f3437",
  "light-gray": "#d1d5db",
  "light-green": "#047857",
  "light-grey": "#d1d5db",
  "light-grey-black": "#0b0b0b",
  "light-grey-citron": "#d1d5db",
  "light-grey-fleck": "#d1d5db",
  "light-grey-french-navy": "#101f3d",
  "light-grey-graphite-grey": "#2f3437",
  "light-grey-heather": "#9ca3af",
  "light-grey-marl": "#c5c7c9",
  "light-grey-marl-black": "#c5c7c9",
  "light-grey-melange": "#b8b8b8",
  "light-grey-white": "#ffffff",
  "light-heather-blue": "#a8d8f0",
  "light-khaki": "#b3ad78",
  "light-melange": "#b8b8b8",
  "light-navy": "#14213d",
  "light-olive": "#8a9a5b",
  "light-oxford": "#c5c7c9",
  "light-pink": "#ffb6c1",
  "light-pink-melange": "#df8fb0",
  "light-pink-natural": "#e8dcc2",
  "light-purple": "#5b21b6",
  "light-red-triblend": "#ef1b1b",
  "light-rose": "#ffb6c1",
  "light-rose-white": "#ffffff",
  "light-royal-blue-melange": "#315c8c",
  "light-smoke-grey-black": "#0b0b0b",
  "light-smoke-grey-obsidian": "#111827",
  "light-smoke-grey-white": "#ffffff",
  "light-stone": "#d6d3d1",
  "light-turquoise": "#40e0d0",
  "light-wash": "#9bb7d4",
  "lightblue": "#a8d8f0",
  "lightbrown": "#a67c52",
  "lightdenim": "#5d7fa3",
  "lightgold": "#d4af37",
  "lightgray": "#d1d5db",
  "lightgrey": "#d1d5db",
  "lightgreymarl": "#c5c7c9",
  "lightgreymelange": "#b8b8b8",
  "lightheatherblue": "#a8d8f0",
  "lightkhaki": "#b3ad78",
  "lightmelange": "#b8b8b8",
  "lightning-green": "#39ff14",
  "lightning-pink": "#ec4899",
  "lightninggreen": "#39ff14",
  "lightolive": "#8a9a5b",
  "lightoxford": "#c5c7c9",
  "lightpink": "#ffb6c1",
  "lightrose": "#ffb6c1",
  "lightstone": "#d6d3d1",
  "lilac": "#c8a2c8",
  "lilac-dream": "#c8a2c8",
  "lilac-melange": "#c8a2c8",
  "lilac-white": "#ffffff",
  "lilacdream": "#c8a2c8",
  "lilacmelange": "#c8a2c8",
  "lime": "#a3e635",
  "lime-black": "#0b0b0b",
  "lime-graphite": "#2f3437",
  "lime-green": "#a3e635",
  "lime-green-graphite-grey": "#2f3437",
  "lime-green-white": "#ffffff",
  "lime-purple": "#5b21b6",
  "lime-royal": "#1d4ed8",
  "lime-std-red": "#d71920",
  "lime-white": "#ffffff",
  "limegreen": "#a3e635",
  "linen": "#e9dcc9",
  "lion-brown": "#6b4f3a",
  "liquorice-zing": "#111111",
  "loden": "#4b5320",
  "lotus-blue": "#7cb9e8",
  "lotus-pink": "#ec4899",
  "lotusblue": "#7cb9e8",
  "magenta": "#ff00ff",
  "magenta-magic": "#ff00ff",
  "magenta-pink": "#ec4899",
  "magestic-purple": "#5b21b6",
  "magestic-purple-seal-grey": "#4b5563",
  "magesticpurple": "#5b21b6",
  "magic-ember": "#c96f3d",
  "magic-ember-arctic-orange-black": "#0b0b0b",
  "magic-mango": "#ffb000",
  "magic-salvia": "#a7b899",
  "magicember": "#c96f3d",
  "magicmango": "#ffb000",
  "magicsalvia": "#a7b899",
  "magma": "#cc5500",
  "magma-black": "#0b0b0b",
  "magnet": "#4b5563",
  "maize-yellow": "#f4d35e",
  "maizeyellow": "#f4d35e",
  "majestic-purple": "#5b21b6",
  "majestic-purple-seal-grey": "#4b5563",
  "majesticpurple": "#5b21b6",
  "mandarin": "#f28500",
  "mango": "#ffb000",
  "mango-sorbet": "#ffb000",
  "mangosorbet": "#ffb000",
  "marie-navy": "#14213d",
  "marienavy": "#14213d",
  "marine": "#123c69",
  "marine-blue": "#123c69",
  "marine-green": "#1f5a4d",
  "marine-od-green": "#3f4a3c",
  "marine-splash": "#123c69",
  "marineblue": "#123c69",
  "marinegreen": "#1f5a4d",
  "marineodgreen": "#3f4a3c",
  "marl": "#9ca3af",
  "marl-grey": "#9ca3af",
  "marlgrey": "#9ca3af",
  "maroon": "#800000",
  "maroon-black": "#0b0b0b",
  "maroon-marl": "#9ca3af",
  "maroon-maroon": "#800000",
  "maroon-triblend": "#800000",
  "maroon-white": "#ffffff",
  "maroon-white-maroon": "#800000",
  "mars-red": "#9f1239",
  "marsred": "#9f1239",
  "mastic": "#c8bfb1",
  "mauve": "#e0b0ff",
  "medium-yellow": "#ffd700",
  "mediumyellow": "#ffd700",
  "melange": "#8f8f8f",
  "melange-black": "#2f2f2f",
  "melange-blue": "#8f8f8f",
  "melange-blue-melange-charcoal": "#315c8c",
  "melange-charcoal": "#8f8f8f",
  "melange-charcoal-black": "#8f8f8f",
  "melange-dark-grey": "#8f8f8f",
  "melange-gray": "#4a4a4a",
  "melange-grey": "#4a4a4a",
  "melange-silver": "#8f8f8f",
  "melange-silver-white": "#8f8f8f",
  "melangeblack": "#2f2f2f",
  "melangegray": "#4a4a4a",
  "melangegrey": "#4a4a4a",
  "melco": "#8f8f8f",
  "mellow-yellow": "#fff44f",
  "mellowyellow": "#fff44f",
  "melon-green": "#93c572",
  "melon-orange": "#ff7900",
  "melon-tint-iron-grey": "#4b5563",
  "melongreen": "#93c572",
  "melonorange": "#ff7900",
  "merlot": "#6f1d3b",
  "mermaid": "#40e0d0",
  "meta-fuchsia": "#ff00ff",
  "meta-gold": "#d4af37",
  "meta-lilac": "#c8a2c8",
  "meta-orange": "#f97316",
  "meta-turquoise": "#40e0d0",
  "metafuchsia": "#ff00ff",
  "metagold": "#d4af37",
  "metal-grey": "#6f7673",
  "metalgrey": "#6f7673",
  "metalilac": "#c8a2c8",
  "metallic-gold": "#d4af37",
  "metallic-silver": "#c0c0c0",
  "metallicgold": "#d4af37",
  "metallicsilver": "#c0c0c0",
  "methyl-blue": "#0057b8",
  "methylblue": "#0057b8",
  "metro-blue": "#1d4ed8",
  "mid-blue": "#2563eb",
  "mid-brown": "#6b4f3a",
  "mid-gray": "#737373",
  "mid-grey": "#737373",
  "mid-heather-blue": "#9ca3af",
  "mid-heather-grey": "#9ca3af",
  "mid-pink": "#ec4899",
  "mid-wash": "#5d7fa3",
  "midblue": "#2563eb",
  "midbrown": "#6b4f3a",
  "midgray": "#737373",
  "midgrey": "#737373",
  "midnight": "#061326",
  "midnight-blue": "#061326",
  "midnight-camo": "#5f6f52",
  "midnight-haze": "#061326",
  "midnight-midnight": "#061326",
  "midnight-navy": "#061326",
  "midnight-navy-midnight-navy-white": "#ffffff",
  "midnight-navy-royal-midnight-navy": "#061326",
  "midnight-navy-white": "#ffffff",
  "midnightblue": "#061326",
  "midnightnavy": "#061326",
  "milennial-khaki": "#b3ad78",
  "milennial-lilac": "#c8a2c8",
  "milennial-mint": "#bdfcc9",
  "milennial-pink": "#ec4899",
  "milennialkhaki": "#b3ad78",
  "milenniallilac": "#c8a2c8",
  "milennialmint": "#bdfcc9",
  "military": "#4b5320",
  "military-green": "#4b5320",
  "military-green-black": "#0b0b0b",
  "military-green-heather": "#9ca3af",
  "military-green-military-green": "#4b5320",
  "militarygreen": "#4b5320",
  "milk-chocolate": "#7b3f00",
  "milkshake-mix": "#999999",
  "millennial-khaki": "#b3ad78",
  "millennial-lilac": "#c8a2c8",
  "millennial-mint": "#bdfcc9",
  "millennial-pink": "#ec4899",
  "millennialkhaki": "#b3ad78",
  "millenniallilac": "#c8a2c8",
  "millennialmint": "#bdfcc9",
  "mindful-blue": "#4f83cc",
  "mindfulblue": "#4f83cc",
  "mineral": "#6f7673",
  "mineral-blue": "#1d4ed8",
  "mineral-grey": "#6f7673",
  "mineral-grey-ash": "#b2beb5",
  "mineral-grey-black": "#0b0b0b",
  "mineralgrey": "#6f7673",
  "mink-beige": "#c8bfb1",
  "minkbeige": "#c8bfb1",
  "mint": "#98ff98",
  "mint-choc-chip": "#98ff98",
  "mint-green": "#98ff98",
  "mint-green-light-grey": "#d1d5db",
  "mint-green-off-white": "#f8f4e8",
  "mint-green-white": "#ffffff",
  "mint-light-grey": "#d1d5db",
  "mintgreen": "#98ff98",
  "mirror-indoor-outdoor": "#c0c0c0",
  "misty-jade": "#00a86b",
  "mix": "#999999",
  "mixed": "#999999",
  "mixed-fabric-colour": "#999999",
  "mixedfabriccolour": "#999999",
  "mocha": "#967969",
  "monarch-laser-orange-brushed-silver": "#c0c0c0",
  "moonstone": "#d1d5db",
  "morning-frost": "#d1d5db",
  "moss": "#8a9a5b",
  "moss-green": "#8a9a5b",
  "moss-green-khaki": "#8a865d",
  "moss-green-white-olive": "#4b5320",
  "moss-khaki": "#8a865d",
  "mossgreen": "#8a9a5b",
  "mountain-blue": "#4f8fbf",
  "mountainblue": "#4f8fbf",
  "mulberry": "#70193d",
  "multi": "#999999",
  "multi-color": "#999999",
  "multi-colour": "#999999",
  "multi-rainbow": "#999999",
  "multicam": "#7b7f55",
  "multicam-arid": "#c2b280",
  "multicam-arid-tan": "#d2b48c",
  "multicam-tropic": "#3f4a3c",
  "multicamarid": "#c2b280",
  "multicamtropic": "#3f4a3c",
  "multicolor": "#999999",
  "multicolour": "#999999",
  "multirainbow": "#999999",
  "mushroom": "#b8a99a",
  "mushroom-natural": "#e8dcc2",
  "mustang-beige": "#e7d8bd",
  "mustard": "#d4a017",
  "mustard-black": "#0b0b0b",
  "mustard-off-white": "#f8f4e8",
  "mustard-white": "#ffffff",
  "myrobalan-stone": "#d6d3d1",
  "natural": "#e8dcc2",
  "natural-black": "#0b0b0b",
  "natural-blue-grey": "#6f8fa3",
  "natural-bright-red": "#ff0000",
  "natural-cappucino": "#c8a99a",
  "natural-caramel": "#c68e17",
  "natural-cream": "#f5f0dc",
  "natural-dark-olive": "#3f4133",
  "natural-dusty-green": "#047857",
  "natural-forest-green": "#228b22",
  "natural-fuchsia": "#ff00ff",
  "natural-grey": "#737373",
  "natural-light-grey": "#d1d5db",
  "natural-lime": "#a3e635",
  "natural-natural": "#e8dcc2",
  "natural-navy": "#14213d",
  "natural-pastel-pink": "#ffb6c1",
  "natural-pink": "#ec4899",
  "natural-pistachio": "#93c572",
  "natural-raw": "#e8dcc2",
  "natural-red": "#ef1b1b",
  "natural-sage-green": "#9caf88",
  "natural-stone": "#d6d3d1",
  "natural-stone-dip-dye": "#d6d3d1",
  "natural-stone-dusty-blue": "#6b8ba4",
  "natural-surf-blue": "#38bdf8",
  "natural-vintage-bottle-green": "#047857",
  "natural-vintage-brown": "#6b4f3a",
  "natural-vintage-denim": "#3f5f85",
  "natural-vintage-light-blue": "#a8d8f0",
  "natural-vintage-red": "#ef1b1b",
  "naturalraw": "#e8dcc2",
  "naturalstone": "#d6d3d1",
  "nature": "#d9c9a8",
  "nautical-navy": "#14213d",
  "nauticalnavy": "#14213d",
  "navy": "#14213d",
  "navy-beige": "#e7d8bd",
  "navy-black": "#0b0b0b",
  "navy-blue": "#14213d",
  "navy-blue-urban-navy": "#14213d",
  "navy-brown": "#6b4f3a",
  "navy-carbon": "#4b5563",
  "navy-charcoal": "#3f3f46",
  "navy-check": "#999999",
  "navy-classic-red": "#d71920",
  "navy-cobalt": "#0047ab",
  "navy-cornflower": "#14213d",
  "navy-dip-dye": "#14213d",
  "navy-dusk": "#6b7280",
  "navy-dusk-tan": "#d2b48c",
  "navy-ebony": "#111111",
  "navy-fleck": "#314158",
  "navy-fluo": "#14213d",
  "navy-french-blue": "#1d4ed8",
  "navy-gold": "#d4af37",
  "navy-granite": "#6b7280",
  "navy-graphite": "#2f3437",
  "navy-green": "#047857",
  "navy-green-check": "#999999",
  "navy-grey": "#737373",
  "navy-greyish-brown": "#6b4f3a",
  "navy-heather": "#314158",
  "navy-heather-grey": "#9ca3af",
  "navy-herringbone": "#999999",
  "navy-hi-vis-yellow": "#eaff00",
  "navy-kelly": "#4cbb17",
  "navy-khaki": "#8a865d",
  "navy-light-blue": "#a8d8f0",
  "navy-light-blue-white": "#ffffff",
  "navy-light-grey": "#d1d5db",
  "navy-light-grey-royal": "#1d4ed8",
  "navy-light-grey-white": "#ffffff",
  "navy-lime": "#a3e635",
  "navy-magma": "#cc5500",
  "navy-marl": "#314158",
  "navy-maroon": "#800000",
  "navy-melange": "#14213d",
  "navy-mist": "#314158",
  "navy-mustard": "#d4a017",
  "navy-natural": "#e8dcc2",
  "navy-navy": "#14213d",
  "navy-navy-melange": "#14213d",
  "navy-new-royal": "#1d4ed8",
  "navy-orange": "#f97316",
  "navy-oxford": "#b8b8b8",
  "navy-oxford-blue": "#1d4ed8",
  "navy-oxford-grey": "#b8b8b8",
  "navy-peacoat": "#14213d",
  "navy-pindot": "#14213d",
  "navy-polka-dot": "#14213d",
  "navy-pure": "#14213d",
  "navy-putty": "#c8bfb1",
  "navy-red": "#ef1b1b",
  "navy-red-tipping": "#14213d",
  "navy-red-white": "#ffffff",
  "navy-royal": "#1d4ed8",
  "navy-royal-royal": "#1d4ed8",
  "navy-royal-white": "#ffffff",
  "navy-sand": "#e7d8bd",
  "navy-sapphire": "#0f52ba",
  "navy-seal": "#4b5563",
  "navy-seal-grey": "#4b5563",
  "navy-silver": "#c0c0c0",
  "navy-sky": "#87ceeb",
  "navy-sky-white": "#ffffff",
  "navy-stone-blue": "#6b8ba4",
  "navy-storm-grey": "#4b5563",
  "navy-stripe-white": "#ffffff",
  "navy-sun-yellow": "#ffd700",
  "navy-surf-blue": "#38bdf8",
  "navy-triblend": "#14213d",
  "navy-turqoise": "#40e0d0",
  "navy-twill": "#14213d",
  "navy-white": "#ffffff",
  "navy-white-aztec": "#ffffff",
  "navy-white-dark-navy": "#071a33",
  "navy-white-navy": "#14213d",
  "navy-white-red": "#ef1b1b",
  "navy-white-stars": "#ffffff",
  "navy-white-stripes": "#ffffff",
  "navy-white-white": "#ffffff",
  "navy-yellow": "#f4ff15",
  "navyblue": "#14213d",
  "navyfleck": "#314158",
  "navyheather": "#314158",
  "navymarl": "#314158",
  "navymelange": "#14213d",
  "navymist": "#314158",
  "navypure": "#14213d",
  "navyroyal": "#14213d",
  "navysky": "#14213d",
  "navywhite": "#14213d",
  "neo-mint": "#a7f3d0",
  "neomint": "#a7f3d0",
  "neon-green": "#39ff14",
  "neon-green-black": "#0b0b0b",
  "neon-orange": "#ff7900",
  "neon-orange-white-olive": "#4b5320",
  "neon-pink": "#ff1493",
  "neon-yellow": "#ccff00",
  "neongreen": "#39ff14",
  "neonorange": "#ff7900",
  "neonpink": "#ff1493",
  "neonyellow": "#ccff00",
  "new-french-navy": "#101f3d",
  "new-french-navy-fire-red": "#e11d48",
  "new-french-navy-heather-grey": "#9ca3af",
  "new-french-navy-sky-blue": "#87ceeb",
  "new-royal": "#1d4ed8",
  "new-royal-black": "#0b0b0b",
  "new-royal-navy": "#14213d",
  "new-sky-blue": "#87ceeb",
  "new-wheat": "#d6b98c",
  "newfrenchnavy": "#101f3d",
  "newroyal": "#1d4ed8",
  "newskyblue": "#87ceeb",
  "newwheat": "#d6b98c",
  "nic-approved-contractor-black": "#0b0b0b",
  "nic-approved-contractor-white": "#ffffff",
  "night-blue": "#0d1b2a",
  "night-blue-marl": "#5d7fa3",
  "night-urban": "#0d1b2a",
  "nightblue": "#0d1b2a",
  "nighturban": "#0d1b2a",
  "nispero": "#d4a017",
  "nordic-blue": "#3b6f9f",
  "nordicblue": "#3b6f9f",
  "nubuck": "#c19a6b",
  "nude": "#d6b98c",
  "nude-melange": "#c8a99a",
  "nude-pink": "#e8b4a6",
  "nudemelange": "#c8a99a",
  "nudepink": "#e8b4a6",
  "oak": "#8b5a2b",
  "oasis-green": "#047857",
  "oasisgreen": "#047857",
  "oat": "#ddd0b8",
  "oatmeal": "#ddd0b8",
  "oatmeal-black": "#0b0b0b",
  "oatmeal-fleck": "#ddd0b8",
  "oatmeal-heather": "#ddd0b8",
  "oatmeal-heather-black-ink": "#ddd0b8",
  "oatmeal-heather-fiery-red-heather": "#ddd0b8",
  "oatmeal-heather-forest-green-heather": "#ddd0b8",
  "oatmeal-heather-indigo-heather": "#ddd0b8",
  "oatmeal-heather-mustard-heather": "#ddd0b8",
  "oatmeal-natural-stone-biscuit": "#d6b98c",
  "oatmeal-white": "#ffffff",
  "oatmealheather": "#ddd0b8",
  "obsidian": "#111827",
  "obsidian-black": "#0b0b0b",
  "obsidian-htr-black": "#0b0b0b",
  "obsidian-white": "#ffffff",
  "ocean": "#005f8f",
  "ocean-blue": "#005f8f",
  "ocean-blue-black": "#0b0b0b",
  "ocean-blue-melange": "#005f8f",
  "ocean-dark-grey": "#2f3437",
  "ocean-depth": "#00445c",
  "ocean-lime": "#a3e635",
  "ocean-teal": "#0f766e",
  "ocean-vliss-baltic-blue-brushed-silver": "#c0c0c0",
  "oceanblue": "#005f8f",
  "oceanbluemelange": "#005f8f",
  "oceandepth": "#00445c",
  "oceanteal": "#0f766e",
  "ocher": "#cc7722",
  "ochre": "#cc7722",
  "octopus": "#7f00ff",
  "off-white": "#f8f4e8",
  "off-white-bright-red": "#ff0000",
  "off-white-french-navy": "#101f3d",
  "off-white-mocha": "#967969",
  "offwhite": "#f8f4e8",
  "old-gold": "#b8860b",
  "oldgold": "#b8860b",
  "olive": "#4b5320",
  "olive-black": "#0b0b0b",
  "olive-camo": "#4b5320",
  "olive-camouflage": "#5f6f52",
  "olive-green": "#4b5320",
  "olive-green-black": "#0b0b0b",
  "olive-green-oatmeal": "#ddd0b8",
  "olive-green-white": "#ffffff",
  "olive-mash": "#4b5320",
  "olive-melange": "#4b5320",
  "olive-natural": "#e8dcc2",
  "olive-night": "#2f3424",
  "olive-stone": "#d6d3d1",
  "olive-triblend": "#4b5320",
  "olive-white-loden": "#4b5320",
  "olivecamo": "#4b5320",
  "olivegreen": "#4b5320",
  "olivemash": "#4b5320",
  "olivemelange": "#4b5320",
  "olivenight": "#2f3424",
  "opaque": "#f8fafc",
  "optic-white": "#ffffff",
  "opticwhite": "#ffffff",
  "orange": "#f97316",
  "orange-black": "#0b0b0b",
  "orange-blue": "#1d4ed8",
  "orange-cat": "#f97316",
  "orange-crush": "#ff7900",
  "orange-dark-grey": "#2f3437",
  "orange-flame": "#ff7900",
  "orange-graphite-grey": "#2f3437",
  "orange-green": "#047857",
  "orange-grey": "#737373",
  "orange-marl": "#9ca3af",
  "orange-natural": "#e8dcc2",
  "orange-navy": "#14213d",
  "orange-orangutan": "#f97316",
  "orange-pumpkin": "#ff7900",
  "orange-red-white-blue": "#1d4ed8",
  "orange-royal-blue": "#1d4ed8",
  "orange-rust": "#cc5500",
  "orange-saturn-yellow": "#f4ff15",
  "orange-vintage": "#f97316",
  "orange-white": "#ffffff",
  "orange-yellow": "#f4ff15",
  "orangecrush": "#ff7900",
  "orangeflame": "#ff7900",
  "orangepumpkin": "#ff7900",
  "orangerust": "#cc5500",
  "orchid": "#da70d6",
  "orchid-flower": "#da70d6",
  "orchid-green": "#047857",
  "orchid-pink": "#da70d6",
  "orchidflower": "#da70d6",
  "orchidpink": "#da70d6",
  "organic-black": "#0b0b0b",
  "organic-camouflage-green": "#047857",
  "organic-cobalt-blue": "#0047ab",
  "organic-fuchsia": "#ff00ff",
  "organic-heather-grey-melange": "#4a4a4a",
  "organic-mocha": "#967969",
  "organic-natural": "#e8dcc2",
  "organic-white": "#ffffff",
  "organicblack": "#0b0b0b",
  "organicnatural": "#e8dcc2",
  "organicwhite": "#ffffff",
  "orion-blue": "#245b8e",
  "orionblue": "#245b8e",
  "owl-light-brown": "#a67c52",
  "oxblood": "#4a0000",
  "oxford": "#b8b8b8",
  "oxford-black": "#0b0b0b",
  "oxford-blue": "#1d4ed8",
  "oxford-blue-black": "#0b0b0b",
  "oxford-blue-briar": "#5c4033",
  "oxford-blue-marl-navy": "#5d7fa3",
  "oxford-blue-orange": "#f97316",
  "oxford-blue-oxford-blue": "#1d4ed8",
  "oxford-blue-seal-grey": "#4b5563",
  "oxford-grey": "#b8b8b8",
  "oxford-navy": "#14213d",
  "oxford-navy-black": "#0b0b0b",
  "oxford-navy-fire-red": "#e11d48",
  "oxford-navy-heather-grey": "#9ca3af",
  "oxford-navy-mustard": "#d4a017",
  "oxford-navy-natural": "#e8dcc2",
  "oxford-navy-navy": "#14213d",
  "oxford-navy-white": "#ffffff",
  "oxford-royal": "#1d4ed8",
  "oxford-true-red": "#d71920",
  "oxfordgrey": "#b8b8b8",
  "oxfordnavy": "#14213d",
  "oyster": "#f7f1e6",
  "oyster-white": "#f7f1e6",
  "oysterwhite": "#f7f1e6",
  "pacific": "#1ca9c9",
  "pacific-grey": "#8b98a3",
  "pacificgrey": "#8b98a3",
  "paisley": "#999999",
  "pal-midnight-navy": "#061326",
  "pale-blue": "#bcdffb",
  "pale-blue-bear": "#bcdffb",
  "pale-gray": "#d9dde2",
  "pale-grey": "#d9dde2",
  "pale-khaki": "#c2b280",
  "pale-khaki-birch": "#c2b280",
  "pale-leaf": "#4f7942",
  "pale-olive": "#4b5320",
  "pale-pink": "#ffb6c1",
  "pale-yellow": "#f4ff15",
  "paleblue": "#bcdffb",
  "palegray": "#d9dde2",
  "palegrey": "#d9dde2",
  "palekhaki": "#c2b280",
  "palepink": "#ffb6c1",
  "palmidnightnavy": "#061326",
  "paper": "#f7f3ea",
  "paradise-orange": "#f97316",
  "paradiseorange": "#f97316",
  "paragon": "#737373",
  "paramedic-green": "#00a651",
  "paramedicgreen": "#00a651",
  "particle-grey": "#737373",
  "particle-grey-heather-black": "#9ca3af",
  "particlegrey": "#737373",
  "pastel-blue": "#bcdffb",
  "pastel-blue-natural": "#e8dcc2",
  "pastel-blue-white": "#ffffff",
  "pastel-green": "#047857",
  "pastel-grey": "#737373",
  "pastel-grey-natural": "#e8dcc2",
  "pastel-lemon": "#fff7a8",
  "pastel-mint": "#bdfcc9",
  "pastel-mint-white": "#ffffff",
  "pastel-pink": "#ffb6c1",
  "pastel-pink-natural": "#e8dcc2",
  "pastel-pink-pastel-pink": "#ffb6c1",
  "pastel-pink-white": "#ffffff",
  "pastel-sunset-dip": "#ffb6c1",
  "pastelblue": "#bcdffb",
  "pastellemon": "#fff7a8",
  "pastelmint": "#bdfcc9",
  "pastelpink": "#ffb6c1",
  "pattern": "#999999",
  "patterned": "#999999",
  "paw-print": "#999999",
  "peach": "#ffcba4",
  "peach-sorbet": "#ffcba4",
  "peacoat": "#14213d",
  "peacock": "#006b73",
  "peacock-blue": "#006b73",
  "peacockblue": "#006b73",
  "pearl-yellow": "#f4ff15",
  "peat": "#5c4a35",
  "pebble": "#b8a99a",
  "penguin-grey": "#8f8f8f",
  "penguingrey": "#8f8f8f",
  "pepper-green": "#4f7942",
  "peppergreen": "#4f7942",
  "peppermint": "#98ff98",
  "peppermint-melange": "#9fe2bf",
  "peppermintmelange": "#9fe2bf",
  "persian-blue": "#1c39bb",
  "persianblue": "#1c39bb",
  "petrol": "#005f6a",
  "petrol-blue": "#005f6a",
  "petrolblue": "#005f6a",
  "pewter": "#899499",
  "photon-dust": "#d6d3d1",
  "photon-dust-black": "#0b0b0b",
  "photon-dust-dust-dark-smoke-grey-black": "#0b0b0b",
  "photon-dust-white": "#ffffff",
  "photondust": "#d6d3d1",
  "pine": "#065f46",
  "pine-green": "#065f46",
  "pinegreen": "#065f46",
  "pink": "#ec4899",
  "pink-bunny": "#ec4899",
  "pink-butterfly": "#ec4899",
  "pink-camo": "#5f6f52",
  "pink-carnation": "#ffb6c1",
  "pink-check": "#999999",
  "pink-dip-dye": "#ec4899",
  "pink-heart": "#ec4899",
  "pink-joy": "#ec4899",
  "pink-lemonade": "#ff9ebd",
  "pink-lime": "#a3e635",
  "pink-marshmellow": "#ec4899",
  "pink-melange": "#df8fb0",
  "pink-melange-hot-pink": "#df8fb0",
  "pink-rabbit": "#ec4899",
  "pink-sixties": "#ec4899",
  "pink-stripe": "#999999",
  "pink-stripe-white": "#ffffff",
  "pink-teddy": "#ec4899",
  "pink-unicorn": "#c8a2c8",
  "pink-white": "#ffffff",
  "pinkcarnation": "#ffb6c1",
  "pinklemonade": "#ff9ebd",
  "pinkmelange": "#df8fb0",
  "pistachio": "#93c572",
  "pistachio-green": "#93c572",
  "pistachiogreen": "#93c572",
  "pistol": "#2a3439",
  "pitch-black": "#050505",
  "pitch-grey": "#737373",
  "pitchblack": "#050505",
  "pixel-coral": "#ff7f50",
  "pixel-lime": "#a3e635",
  "pixelcoral": "#ff7f50",
  "plaster": "#d6d3d1",
  "platinum": "#e5e4e2",
  "platinum-grey": "#e5e4e2",
  "platinumgrey": "#e5e4e2",
  "plum": "#673147",
  "plum-purple": "#673147",
  "plumpurple": "#673147",
  "polar-bear-cream": "#f5f0dc",
  "polarbearcream": "#f5f0dc",
  "pomegranate-rose": "#f43f5e",
  "pomegranaterose": "#f43f5e",
  "pomegranite-rose": "#f43f5e",
  "pomegraniterose": "#f43f5e",
  "pool-blue": "#38bdf8",
  "poolblue": "#38bdf8",
  "pop-green": "#8db600",
  "pop-tomato": "#e43d30",
  "pop-turquoise": "#40e0d0",
  "pop-yellow": "#f4ff15",
  "popgreen": "#8db600",
  "popturquoise": "#40e0d0",
  "port": "#4b1f2f",
  "poseidon-black": "#111111",
  "poseidon-blue": "#1d4ed8",
  "poseidonblack": "#111111",
  "potters-clay": "#b66a50",
  "pottersclay": "#b66a50",
  "powder": "#6f7673",
  "powder-blue": "#b0e0e6",
  "powder-gray": "#6f7673",
  "powder-grey": "#6f7673",
  "powder-pink": "#ec4899",
  "powder-rose": "#f43f5e",
  "powderblue": "#b0e0e6",
  "powdergray": "#6f7673",
  "powdergrey": "#6f7673",
  "powdery-yellow": "#fff8a8",
  "powderyyellow": "#fff8a8",
  "prairie-dust": "#c2b280",
  "prarie-dust": "#c2b280",
  "print": "#999999",
  "prism-pink": "#ff69b4",
  "prismpink": "#ff69b4",
  "psychic-blue-black": "#0b0b0b",
  "pumpkin": "#ff7900",
  "pumpkin-pie": "#cc5500",
  "pumpkinpie": "#cc5500",
  "pure-green": "#00a651",
  "pure-green-white": "#ffffff",
  "pure-orange": "#f97316",
  "pure-red": "#d71920",
  "pure-sky": "#87ceeb",
  "puregreen": "#00a651",
  "pureorange": "#f97316",
  "purered": "#d71920",
  "purple": "#5b21b6",
  "purple-arctic-white": "#ffffff",
  "purple-black": "#0b0b0b",
  "purple-charcoal": "#3f3f46",
  "purple-gold": "#d4af37",
  "purple-grey": "#737373",
  "purple-light-grey": "#d1d5db",
  "purple-lilac": "#c8a2c8",
  "purple-love": "#5b21b6",
  "purple-marl": "#9ca3af",
  "purple-natural": "#e8dcc2",
  "purple-night": "#5b21b6",
  "purple-octopus": "#7f00ff",
  "purple-pink": "#ec4899",
  "purple-sun-yellow": "#ffd700",
  "purple-turquoise": "#40e0d0",
  "purple-white": "#ffffff",
  "purple-yellow": "#f4ff15",
  "putty": "#c8bfb1",
  "putty-french-navy": "#101f3d",
  "putty-navy": "#14213d",
  "quarry": "#6b7280",
  "quartz-blue": "#6baed6",
  "quartz-dark-navy": "#071a33",
  "quartzblue": "#6baed6",
  "radiant-purple": "#7c3aed",
  "radiantpurple": "#7c3aed",
  "rainbow": "#999999",
  "rainbow-bear-multi": "#999999",
  "rainbowbearmulti": "#999999",
  "rainforest-green": "#0b5d35",
  "rainforestgreen": "#0b5d35",
  "ranger": "#3f4a3c",
  "ranger-green": "#3f4a3c",
  "rangergreen": "#3f4a3c",
  "raspberry": "#c72c48",
  "raspberry-lime": "#a3e635",
  "raspberry-ripple": "#c72c48",
  "raspberry-white": "#ffffff",
  "raspberryripple": "#c72c48",
  "ready-for-dye": "#f8f4e8",
  "ready-to-dye": "#f8f4e8",
  "real-green": "#00a651",
  "real-turquoise": "#40e0d0",
  "realgreen": "#00a651",
  "realturquoise": "#40e0d0",
  "red": "#ef1b1b",
  "red-black": "#0b0b0b",
  "red-black-black": "#0b0b0b",
  "red-black-white": "#ffffff",
  "red-brown": "#8b3a2f",
  "red-camo": "#5f6f52",
  "red-earth": "#a0522d",
  "red-gray": "#737373",
  "red-grey": "#737373",
  "red-hi-vis-yellow": "#eaff00",
  "red-hot-chilli": "#b91c1c",
  "red-light-grey-white": "#ffffff",
  "red-marl": "#9ca3af",
  "red-mist": "#ef1b1b",
  "red-navy": "#14213d",
  "red-navy-check": "#999999",
  "red-red": "#ef1b1b",
  "red-stripe": "#999999",
  "red-triblend": "#ef1b1b",
  "red-white": "#ffffff",
  "red-white-black": "#0b0b0b",
  "red-white-red": "#ef1b1b",
  "red-white-royal": "#1d4ed8",
  "red-white-stripe": "#999999",
  "red-white-stripes": "#ffffff",
  "red-yellow": "#f4ff15",
  "redbrown": "#8b3a2f",
  "redearth": "#a0522d",
  "redwhite": "#ef1b1b",
  "redwood": "#7b3f2f",
  "reef-blue": "#38bdf8",
  "reefblue": "#38bdf8",
  "reflective": "#c0c0c0",
  "reflective-silver": "#c0c0c0",
  "reflectivesilver": "#c0c0c0",
  "reflex-blue": "#001489",
  "reflex-silver": "#c0c0c0",
  "reflexblue": "#001489",
  "reflexsilver": "#c0c0c0",
  "reindeer-brown": "#6b4f3a",
  "retro-blues": "#1d4ed8",
  "retro-green": "#047857",
  "retro-heather-green": "#9ca3af",
  "retro-heather-royal": "#9ca3af",
  "ribbon-pink": "#ffb6c1",
  "ribbonpink": "#ffb6c1",
  "rich-violet": "#7f00ff",
  "richviolet": "#7f00ff",
  "rift": "#6b7280",
  "roasted-coffee": "#4b2e20",
  "roastedcoffee": "#4b2e20",
  "roccoco-red": "#9b111e",
  "roccocored": "#9b111e",
  "rock": "#6b7280",
  "rock-grey": "#6b7280",
  "rock-grey-black": "#0b0b0b",
  "rockgrey": "#6b7280",
  "rocky-peaks": "#6b7280",
  "rococco-red": "#9b111e",
  "rococcored": "#9b111e",
  "rose": "#f43f5e",
  "rose-brown": "#6b4f3a",
  "rose-gold": "#b76e79",
  "rose-peach-vanilla": "#f3e5ab",
  "rose-quartz": "#f7cac9",
  "rosegold": "#b76e79",
  "rosequartz": "#f7cac9",
  "royal": "#1d4ed8",
  "royal-black": "#0b0b0b",
  "royal-blue": "#1d4ed8",
  "royal-blue-arctic-white": "#ffffff",
  "royal-blue-jet-black": "#050505",
  "royal-blue-navy": "#14213d",
  "royal-blue-navy-white": "#ffffff",
  "royal-blue-white": "#ffffff",
  "royal-blue-white-storm-grey": "#4b5563",
  "royal-dark-navy": "#071a33",
  "royal-grey": "#737373",
  "royal-hi-vis-yellow": "#eaff00",
  "royal-light-grey": "#d1d5db",
  "royal-lime": "#a3e635",
  "royal-marl": "#9ca3af",
  "royal-natural": "#e8dcc2",
  "royal-navy": "#14213d",
  "royal-off-white": "#f8f4e8",
  "royal-orange": "#f97316",
  "royal-white": "#ffffff",
  "royal-white-royal": "#1d4ed8",
  "royalblue": "#1d4ed8",
  "royalwhite": "#1d4ed8",
  "ruby": "#9b111e",
  "ruby-red": "#9b111e",
  "rubyred": "#9b111e",
  "russet": "#8b3a2f",
  "rust": "#b7410e",
  "rustic-orange": "#b7410e",
  "rustic-orange-khaki": "#8a865d",
  "rusticorange": "#b7410e",
  "safety-green": "#a3e635",
  "safety-orange": "#ff7900",
  "safetygreen": "#a3e635",
  "safetyorange": "#ff7900",
  "saga-green-melange": "#8f8f8f",
  "sage": "#9caf88",
  "sage-green": "#9caf88",
  "sage-green-melange": "#9caf88",
  "sage-marl": "#9caf88",
  "sagegreen": "#9caf88",
  "sagegreenmelange": "#9caf88",
  "sagemarl": "#9caf88",
  "sahara": "#c2b280",
  "salmon": "#fa8072",
  "salmon-pink": "#fa8072",
  "salmonpink": "#fa8072",
  "sand": "#e7d8bd",
  "sand-black": "#0b0b0b",
  "sand-dune": "#d9c6a3",
  "sanddune": "#d9c6a3",
  "sandstone": "#d6c3a5",
  "sandstorm": "#ecd540",
  "sapphire": "#0f52ba",
  "sapphire-blue": "#0f52ba",
  "sapphire-blue-azure-blue": "#007fff",
  "sapphire-blue-charcoal": "#3f3f46",
  "sapphire-blue-french-navy-white": "#ffffff",
  "sapphire-blue-heather-grey": "#9ca3af",
  "sapphire-heather-grey": "#9ca3af",
  "sapphire-natural": "#e8dcc2",
  "sapphireblue": "#0f52ba",
  "saturn-yellow": "#f4ff15",
  "saturn-yellow-navy": "#14213d",
  "saturn-yellow-royal": "#1d4ed8",
  "saturnyellow": "#f4ff15",
  "saturnyellow-black": "#0b0b0b",
  "saturnyellow-grey": "#737373",
  "saturnyellow-red": "#ef1b1b",
  "scarlet": "#ff2400",
  "scarlet-red": "#ff2400",
  "scarletred": "#ff2400",
  "sea-blue": "#1d4ed8",
  "sea-foam": "#9fe2bf",
  "sea-grass": "#8a9a5b",
  "seafoam": "#9fe2bf",
  "seafoam-green": "#9fe2bf",
  "seafoamgreen": "#9fe2bf",
  "seagrass": "#8a9a5b",
  "seal": "#4b5563",
  "seal-black": "#0b0b0b",
  "seal-gray": "#4b5563",
  "seal-grey": "#4b5563",
  "seal-grey-black": "#0b0b0b",
  "seal-grey-marl": "#9ca3af",
  "seal-grey-seal-grey": "#4b5563",
  "sealgray": "#4b5563",
  "sealgrey": "#4b5563",
  "serene-blue": "#7cb9e8",
  "sereneblue": "#7cb9e8",
  "shadow": "#4b5563",
  "shadow-grey": "#737373",
  "shark-grey": "#5f6368",
  "sharkgrey": "#5f6368",
  "sherbert-dip": "#fff44f",
  "sherbet-lemon": "#fff44f",
  "sherbetlemon": "#fff44f",
  "silver": "#c0c0c0",
  "silver-grey": "#b8b8b8",
  "silver-reflective": "#c0c0c0",
  "silver-silver": "#c0c0c0",
  "silver-white": "#ffffff",
  "silver-white-silver": "#c0c0c0",
  "silvergrey": "#b8b8b8",
  "silverreflective": "#c0c0c0",
  "sizzling-red": "#e11d48",
  "sizzlingred": "#e11d48",
  "sky": "#87ceeb",
  "sky-blue": "#87ceeb",
  "sky-blue-french-navy": "#101f3d",
  "sky-blue-light-grey": "#d1d5db",
  "sky-blue-marl": "#5d7fa3",
  "sky-blue-melange": "#87ceeb",
  "sky-blue-stripe": "#999999",
  "sky-blue-white": "#ffffff",
  "sky-french-navy-white": "#ffffff",
  "sky-light-grey": "#d1d5db",
  "sky-marl": "#9ca3af",
  "sky-navy": "#14213d",
  "sky-white": "#ffffff",
  "skyblue": "#87ceeb",
  "skybluemelange": "#87ceeb",
  "skydiver": "#38bdf8",
  "slate": "#475569",
  "slate-blue": "#1d4ed8",
  "slate-blue-light-grey": "#d1d5db",
  "slate-grey": "#475569",
  "slate-grey-black": "#0b0b0b",
  "slate-grey-light-grey-black": "#0b0b0b",
  "slate-light-grey": "#d1d5db",
  "slate-light-grey-natural": "#e8dcc2",
  "slate-navy": "#14213d",
  "slategrey": "#475569",
  "smoke": "#6b7280",
  "smoke-black-orange": "#f97316",
  "smoke-orange": "#f97316",
  "snow": "#ffffff",
  "snow-blossom": "#ffffff",
  "soft-blue": "#bcdffb",
  "soft-cream": "#f5ead5",
  "soft-grey": "#c9c9c9",
  "soft-grey-marl": "#9ca3af",
  "soft-khaki": "#b3ad78",
  "soft-lavender": "#c8a2c8",
  "soft-mint": "#c4f1de",
  "soft-olive": "#8a9a5b",
  "soft-peach": "#ffcba4",
  "soft-pink": "#ffb6c1",
  "soft-rose": "#f43f5e",
  "soft-salvia": "#a7b899",
  "soft-white": "#f7f3ea",
  "soft-white-black": "#0b0b0b",
  "soft-white-light-grey": "#d1d5db",
  "soft-white-rose-gold": "#b76e79",
  "soft-yellow": "#f4ff15",
  "softblue": "#bcdffb",
  "softcream": "#f5ead5",
  "softgrey": "#c9c9c9",
  "softkhaki": "#b3ad78",
  "softlavender": "#c8a2c8",
  "softmint": "#c4f1de",
  "softolive": "#8a9a5b",
  "softpink": "#ffb6c1",
  "softsalvia": "#a7b899",
  "softwhite": "#f7f3ea",
  "solar-pink": "#ff1493",
  "solar-yellow": "#f4ff15",
  "solarpink": "#ff1493",
  "solid-baby-blue-blend": "#89cff0",
  "solid-black": "#000000",
  "solid-black-blend": "#000000",
  "solid-black-triblend": "#000000",
  "solid-charcoal": "#3f3f46",
  "solid-grey": "#737373",
  "solid-natural-blend": "#e8dcc2",
  "solid-navy": "#14213d",
  "solid-navy-blend": "#14213d",
  "solid-pink-blend": "#ec4899",
  "solid-red-blend": "#ef1b1b",
  "solid-white": "#ffffff",
  "solid-white-blend": "#ffffff",
  "solidblack": "#000000",
  "solidwhite": "#ffffff",
  "sorbet": "#ffcba4",
  "sour-green": "#8db600",
  "sourgreen": "#8db600",
  "space-grey": "#6b7280",
  "space-grey-black": "#0b0b0b",
  "space-grey-grey-melange": "#4a4a4a",
  "spacegrey": "#6b7280",
  "spectra-yellow": "#f4ff15",
  "spectrayellow": "#f4ff15",
  "spice-orange": "#cc5500",
  "spiced-coral": "#e26d5a",
  "spicedcoral": "#e26d5a",
  "spiceorange": "#cc5500",
  "spider-black": "#111111",
  "spider-navy": "#14213d",
  "spider-pink": "#ec4899",
  "spider-purple": "#5b21b6",
  "spider-royal": "#1d4ed8",
  "spiderblack": "#111111",
  "sport-dark-navy": "#071a33",
  "sport-green": "#047857",
  "sport-grey": "#c5c7c9",
  "sport-grey-rs": "#c5c7c9",
  "sport-heather": "#9ca3af",
  "sport-royal": "#1d4ed8",
  "sport-scarlett-red": "#ef1b1b",
  "sportdarknavy": "#071a33",
  "sportgrey": "#c5c7c9",
  "sportroyal": "#1d4ed8",
  "sports-grey": "#c5c7c9",
  "sportsgrey": "#c5c7c9",
  "sporty-blue": "#1d4ed8",
  "sporty-coral": "#ff7f50",
  "sporty-grey-black": "#0b0b0b",
  "sporty-khaki": "#8a865d",
  "sporty-navy": "#14213d",
  "sporty-navy-sporty-navy": "#14213d",
  "sporty-royal-blue": "#1d4ed8",
  "sportykhaki": "#8a865d",
  "sportynavy": "#14213d",
  "sportyroyalblue": "#1d4ed8",
  "spring-break": "#00a651",
  "spruce": "#0f3d2e",
  "spruce-darkest-spruce": "#0f3d2e",
  "spruce-green": "#0f3d2e",
  "spruce-mallard": "#0f3d2e",
  "sprucegreen": "#0f3d2e",
  "stadium-red-black": "#0b0b0b",
  "stargazer": "#061326",
  "stay-black": "#050505",
  "stayblack": "#050505",
  "std-red": "#d71920",
  "stdred": "#d71920",
  "steel": "#71797e",
  "steel-black": "#0b0b0b",
  "steel-blue": "#4682b4",
  "steel-blue-silver": "#c0c0c0",
  "steel-gray": "#71797e",
  "steel-grey": "#71797e",
  "steel-grey-jet-black": "#050505",
  "steel-mid-grey": "#737373",
  "steelblue": "#4682b4",
  "steelgray": "#71797e",
  "steelgrey": "#71797e",
  "stem-green": "#4f7942",
  "stemgreen": "#4f7942",
  "stone": "#d6d3d1",
  "stone-black": "#0b0b0b",
  "stone-blue": "#6b8ba4",
  "stone-gray": "#8b8b8b",
  "stone-grey": "#8b8b8b",
  "stone-olive": "#4b5320",
  "stone-shadow-grey": "#737373",
  "stoneblue": "#6b8ba4",
  "stonegray": "#8b8b8b",
  "stonegrey": "#8b8b8b",
  "storm": "#4b5563",
  "storm-dark-grey": "#2f3437",
  "storm-dark-grey-natural": "#e8dcc2",
  "storm-grey": "#4b5563",
  "storm-grey-navy": "#14213d",
  "storm-greys": "#4b5563",
  "stormgrey": "#4b5563",
  "strawberry-haze": "#de5d83",
  "strawberry-red": "#e11d48",
  "strawberryred": "#e11d48",
  "stripe": "#999999",
  "striped": "#999999",
  "strong-blue-navy": "#14213d",
  "sublimation-white": "#ffffff",
  "sublimationwhite": "#ffffff",
  "submarine-yellow": "#f4ff15",
  "submarine-yellow-grey": "#737373",
  "submarineyellow": "#f4ff15",
  "sulfer-black": "#0b0b0b",
  "summer-blue": "#66c7ff",
  "summerblue": "#66c7ff",
  "sun": "#ffd700",
  "sun-orange-seal-grey": "#4b5563",
  "sun-yellow": "#ffd700",
  "sunflower": "#ffda03",
  "sunflower-black": "#0b0b0b",
  "sunflower-heritage-blue": "#1d4ed8",
  "sunflower-kelly-green": "#4cbb17",
  "sunflower-natural": "#e8dcc2",
  "sunflower-white": "#ffffff",
  "sunset": "#f97316",
  "sunset-orange": "#f97316",
  "sunset-reds": "#f97316",
  "sunsetorange": "#f97316",
  "sunshine": "#ffd700",
  "sunyellow": "#ffd700",
  "supa-black": "#050505",
  "supablack": "#050505",
  "super-hero": "#1d4ed8",
  "super-pink": "#ff69b4",
  "super-pink-white": "#ffffff",
  "superpink": "#ff69b4",
  "surf-blue": "#38bdf8",
  "surf-blue-graphite-grey": "#2f3437",
  "surf-blue-off-white": "#f8f4e8",
  "surfblue": "#38bdf8",
  "sweet-cream-heather": "#e8dcc2",
  "sweet-pink": "#ffb6c1",
  "sweetcreamheather": "#e8dcc2",
  "sweetpink": "#ffb6c1",
  "swimming-pool": "#38bdf8",
  "swiss-navy": "#14213d",
  "swissnavy": "#14213d",
  "tahiti-coral": "#ff7f50",
  "tahiticoral": "#ff7f50",
  "tan": "#d2b48c",
  "tangerine": "#f28500",
  "tape": "#8a865d",
  "tartan": "#999999",
  "taupe": "#8b8589",
  "taxi-yellow": "#ffcc00",
  "taxiyellow": "#ffcc00",
  "teal": "#0f766e",
  "teal-french-navy": "#101f3d",
  "teal-grey": "#737373",
  "teal-heather": "#0f766e",
  "teal-monstera": "#0f766e",
  "teal-white": "#ffffff",
  "tealheather": "#0f766e",
  "team-college-red": "#d71920",
  "team-green": "#047857",
  "team-navy-blue": "#14213d",
  "team-purple": "#5b21b6",
  "teamcollegered": "#d71920",
  "teamgreen": "#047857",
  "teddy-light-brown": "#a67c52",
  "teddy-white": "#ffffff",
  "terracota": "#c65a3a",
  "terracotta": "#c65a3a",
  "texas-orange": "#bf5700",
  "texasorange": "#bf5700",
  "textured-stripe": "#999999",
  "texturedstripe": "#999999",
  "thunder-blue": "#1f4e79",
  "thunderblue": "#1f4e79",
  "tie-dye-swirl": "#999999",
  "tiedyeswirl": "#999999",
  "tiger-gold": "#d4af37",
  "tiger-melange": "#b56c23",
  "tigergold": "#d4af37",
  "tigermelange": "#b56c23",
  "titanium": "#878681",
  "toast": "#c19a6b",
  "tobacco": "#71543e",
  "toffee": "#c68e17",
  "toffee-black": "#0b0b0b",
  "tomato-red": "#e43d30",
  "tomatored": "#e43d30",
  "track-red-dark-driftwood-white": "#ffffff",
  "transparent": "#f8fafc",
  "tropic": "#0f766e",
  "tropical-blue": "#00a3e0",
  "tropical-greens": "#047857",
  "tropical-twist-obsidian": "#111827",
  "tropicalblue": "#00a3e0",
  "true-black": "#000000",
  "true-pink": "#ff69b4",
  "true-pink-classic-red": "#d71920",
  "true-purple": "#5b21b6",
  "true-red": "#d71920",
  "true-red-black": "#0b0b0b",
  "true-royal": "#1d4ed8",
  "true-royal-triblend": "#1d4ed8",
  "true-yellow": "#f4ff15",
  "trueblack": "#000000",
  "truepink": "#ff69b4",
  "truepurple": "#5b21b6",
  "truered": "#d71920",
  "trueroyal": "#1d4ed8",
  "trueyellow": "#f4ff15",
  "truffle": "#4b2e20",
  "turqoise": "#40e0d0",
  "turquoise": "#40e0d0",
  "turquoise-black": "#0b0b0b",
  "turquoise-blue": "#40e0d0",
  "turquoise-natural": "#e8dcc2",
  "turquoise-red": "#ef1b1b",
  "turquoise-surf": "#40e0d0",
  "turquoise-white": "#ffffff",
  "turquoiseblue": "#40e0d0",
  "turquoisesurf": "#40e0d0",
  "tweed": "#8b8589",
  "typhon": "#6b7280",
  "typhoon": "#6b7280",
  "ultra-yellow": "#f4ff15",
  "ultrayellow": "#f4ff15",
  "unicorn": "#c8a2c8",
  "unicorn-pink": "#ec4899",
  "union-beige": "#c8b99a",
  "unionbeige": "#c8b99a",
  "university-blue": "#3b82f6",
  "university-blue-white": "#ffffff",
  "university-red": "#d71920",
  "university-red-white": "#ffffff",
  "universityblue": "#3b82f6",
  "universityred": "#d71920",
  "urban": "#6b7280",
  "urban-camo": "#6b7280",
  "urban-grey": "#5f6368",
  "urban-khaki": "#8a865d",
  "urban-orange": "#cc5500",
  "urban-purple": "#5b21b6",
  "urbancamo": "#6b7280",
  "urbangrey": "#5f6368",
  "urbanorange": "#cc5500",
  "used-black": "#111111",
  "usedblack": "#111111",
  "vanilla": "#f3e5ab",
  "vanilla-biscuit": "#d6b98c",
  "vanilla-milkshake": "#efe1c6",
  "vanillamilkshake": "#efe1c6",
  "vegas-gold": "#c5b358",
  "vegasgold": "#c5b358",
  "very-turquoise": "#40e0d0",
  "veryturquoise": "#40e0d0",
  "vibrant-purple": "#7c3aed",
  "vibrant-purple-white": "#ffffff",
  "vibrantpurple": "#7c3aed",
  "vintage-aqua": "#00ffff",
  "vintage-black": "#0b0b0b",
  "vintage-black-stone": "#d6d3d1",
  "vintage-blue": "#1d4ed8",
  "vintage-bottle-green": "#047857",
  "vintage-brown": "#6b4f3a",
  "vintage-brown-stone": "#d6d3d1",
  "vintage-cornflower": "#6495ed",
  "vintage-denim": "#3f5f85",
  "vintage-denim-stone": "#d6d3d1",
  "vintage-dusky-pink": "#d88ca1",
  "vintage-grey": "#737373",
  "vintage-heather-navy": "#9ca3af",
  "vintage-heather-red": "#9ca3af",
  "vintage-jungle-camo": "#4b5320",
  "vintage-light-blue": "#a8d8f0",
  "vintage-light-denim": "#5d7fa3",
  "vintage-light-grey": "#d1d5db",
  "vintage-military-green": "#4b5320",
  "vintage-mustard": "#d4a017",
  "vintage-olive": "#4b5320",
  "vintage-olive-stone": "#d6d3d1",
  "vintage-orange": "#f97316",
  "vintage-oxford-navy": "#14213d",
  "vintage-red": "#ef1b1b",
  "vintage-sage-green": "#9caf88",
  "vintage-sand": "#e7d8bd",
  "vintage-stone": "#b8a99a",
  "vintagebottlegreen": "#047857",
  "vintagedenim": "#3f5f85",
  "vintageolive": "#4b5320",
  "vintagesagegreen": "#9caf88",
  "vintagestone": "#b8a99a",
  "viola-blue": "#5b7bb2",
  "violablue": "#5b7bb2",
  "violet": "#7f00ff",
  "visibility-green": "#a3e635",
  "visibility-orange": "#ff5f00",
  "visibility-yellow": "#eaff00",
  "visibilitygreen": "#a3e635",
  "visibilityorange": "#ff5f00",
  "visibilityyellow": "#eaff00",
  "viva-yellow": "#f4ff15",
  "vivayellow": "#f4ff15",
  "vivid-blue": "#0066cc",
  "vivid-green": "#047857",
  "vivid-green-black": "#0b0b0b",
  "vivid-red": "#d71920",
  "vivid-yellow": "#f4ff15",
  "vividblue": "#0066cc",
  "vividred": "#d71920",
  "vividyellow": "#f4ff15",
  "volcano-stone": "#6b4f3a",
  "walnut": "#71543e",
  "walnut-black": "#0b0b0b",
  "warm-sand": "#e7d8bd",
  "warmsand": "#e7d8bd",
  "washed-blue-denim": "#5d7fa3",
  "washed-charcoal": "#3f3f46",
  "washed-coral-nautical-design": "#ff7f50",
  "washed-denim": "#5d7fa3",
  "washed-grey-melange": "#4a4a4a",
  "washed-indigo": "#1e3a8a",
  "washed-jet-black": "#1b1b1b",
  "washedbluedenim": "#5d7fa3",
  "washeddenim": "#5d7fa3",
  "washedjetblack": "#1b1b1b",
  "watermellon-breeze": "#ff7eb9",
  "wg-grey": "#737373",
  "wg-grey-black": "#0b0b0b",
  "wggrey": "#737373",
  "wheat": "#d6b98c",
  "white": "#ffffff",
  "white-angel-bear": "#ffffff",
  "white-anthracite-light-lemon-twist": "#25282a",
  "white-aqua": "#00ffff",
  "white-baby-blue": "#89cff0",
  "white-black": "#0b0b0b",
  "white-black-arctic-orange": "#ff7900",
  "white-black-black": "#0b0b0b",
  "white-black-melange": "#2f2f2f",
  "white-black-pure-platinum": "#e5e4e2",
  "white-blue": "#1d4ed8",
  "white-bright-red": "#ff0000",
  "white-deep-navy": "#071a33",
  "white-dolphin": "#6b7280",
  "white-fire-red-green": "#047857",
  "white-fleck-triblend": "#ffffff",
  "white-forest": "#228b22",
  "white-french-navy": "#101f3d",
  "white-fuchsia": "#ff00ff",
  "white-ghost": "#ffffff",
  "white-graphite": "#2f3437",
  "white-green": "#047857",
  "white-green-leaf": "#4f7942",
  "white-grey": "#737373",
  "white-greyandblack": "#ffffff",
  "white-heather-grey": "#9ca3af",
  "white-herringbone": "#999999",
  "white-kelly": "#4cbb17",
  "white-kelly-green": "#4cbb17",
  "white-light-grey-royal": "#1d4ed8",
  "white-light-lemon-twist-black": "#0b0b0b",
  "white-maroon": "#800000",
  "white-multi-check": "#999999",
  "white-natural": "#e8dcc2",
  "white-nautical-navy": "#14213d",
  "white-navy": "#14213d",
  "white-navy-leaf": "#4f7942",
  "white-out": "#ffffff",
  "white-oxford-grey": "#b8b8b8",
  "white-oxford-navy": "#14213d",
  "white-pale-blue": "#bcdffb",
  "white-pale-pink": "#ffb6c1",
  "white-pink": "#ec4899",
  "white-pink-check": "#999999",
  "white-pink-white-stripe": "#999999",
  "white-powder-pink": "#ec4899",
  "white-red": "#ef1b1b",
  "white-red-storm-grey": "#4b5563",
  "white-royal": "#1d4ed8",
  "white-royal-blue": "#1d4ed8",
  "white-royal-storm-grey": "#4b5563",
  "white-sand": "#f0e4c8",
  "white-sand-toffee": "#c68e17",
  "white-silver-convoy-grey": "#6b7280",
  "white-sky-grey": "#737373",
  "white-true-royal": "#1d4ed8",
  "white-white": "#ffffff",
  "white-yellow": "#f4ff15",
  "whiteout": "#ffffff",
  "whitesand": "#f0e4c8",
  "wideland": "#8a865d",
  "wild-mulberry": "#70193d",
  "wilderness-green": "#3f4a3c",
  "wildernessgreen": "#3f4a3c",
  "wine": "#6f1d3b",
  "winter-berries": "#9f1239",
  "winter-emerald": "#047857",
  "winter-sky": "#87ceeb",
  "winteremerald": "#047857",
  "wolf-grey-black": "#0b0b0b",
  "wolf-grey-black-black": "#0b0b0b",
  "wolf-grey-white": "#ffffff",
  "wood": "#71543e",
  "wood-camo": "#71543e",
  "wood-camo-black": "#0b0b0b",
  "woodcamo": "#71543e",
  "woodland": "#3f4a3c",
  "woods": "#3f4a3c",
  "worker-blue": "#2f6f9f",
  "workerblue": "#2f6f9f",
  "workguard-grey": "#737373",
  "workguardgrey": "#737373",
  "wraith": "#6b7280",
  "yellow": "#f4ff15",
  "yellow-black": "#0b0b0b",
  "yellow-blue": "#1d4ed8",
  "yellow-bottle": "#047857",
  "yellow-dark-grey": "#2f3437",
  "yellow-fizz": "#f4ff15",
  "yellow-graphite-grey": "#2f3437",
  "yellow-green": "#047857",
  "yellow-grey": "#737373",
  "yellow-haze": "#f4ff15",
  "yellow-hi-vis-red": "#ef1b1b",
  "yellow-marl": "#9ca3af",
  "yellow-navy": "#14213d",
  "yellow-purple": "#5b21b6",
  "yellow-red": "#ef1b1b",
  "yellow-royal": "#1d4ed8",
  "yellow-royal-blue": "#1d4ed8",
  "zest": "#ccff00",
  "zinc": "#7c7f82",
  "zinc-stripe": "#7c7f82",
  "zincstripe": "#7c7f82",
  "zoom-grey": "#8e9397",
  "zoom-grey-black": "#0b0b0b",
  "zoomgrey": "#8e9397",


  
};

window.WSM_NORMALISE_COLOUR = function(name) {
  return String(name || '')
    .toLowerCase()
    .trim()
    .replace(/[’‘]/g, "'")
    .replace(/&/g, 'and')
    .replace(/\+/g, 'and')
    .replace(/\//g, '-')
    .replace(/\s+/g, '-')
    .replace(/_/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

window.WSM_SPLIT_COLOUR_PARTS = function(name) {
  var text = String(name || '').trim();

  if (!text) return [];

  if (
    text.indexOf('/') === -1 &&
    text.indexOf('+') === -1 &&
    text.indexOf('&') === -1 &&
    text.toLowerCase().indexOf(' and ') === -1 &&
    text.toLowerCase().indexOf(' with ') === -1 &&
    text.indexOf(' - ') === -1
  ) {
    return [];
  }

  return text
    .replace(/\s*\/\s*/g, '|')
    .replace(/\s*\+\s*/g, '|')
    .replace(/\s*&\s*/g, '|')
    .replace(/\s+\band\b\s+/gi, '|')
    .replace(/\s+\bwith\b\s+/gi, '|')
    .replace(/\s+-\s+/g, '|')
    .split('|')
    .map(function(part) {
      return String(part || '')
        .replace(/\btrim\b/gi, '')
        .replace(/\bcontrast\b/gi, '')
        .replace(/\bpanel\b/gi, '')
        .replace(/\bpanels\b/gi, '')
        .replace(/\bdetail\b/gi, '')
        .replace(/\bdetails\b/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
    })
    .filter(Boolean);
};

window.WSM_MAKE_GRADIENT = function(colours) {
  colours = (colours || []).filter(Boolean).slice(0, 3);

  if (colours.length === 2) {
    return 'linear-gradient(135deg, ' +
      colours[0] + ' 0%, ' +
      colours[0] + ' 50%, ' +
      colours[1] + ' 50%, ' +
      colours[1] + ' 100%)';
  }

  if (colours.length === 3) {
    return 'linear-gradient(135deg, ' +
      colours[0] + ' 0%, ' +
      colours[0] + ' 33.33%, ' +
      colours[1] + ' 33.33%, ' +
      colours[1] + ' 66.66%, ' +
      colours[2] + ' 66.66%, ' +
      colours[2] + ' 100%)';
  }

  return colours[0] || null;
};

window.WSM_GET_COLOUR = function(name, fallback = '#cccccc') {
  const raw = String(name || '').trim();

  if (!raw) return fallback;

  /*
    If the incoming value is a true combo, return a gradient.
    This does NOT split plain spaces, so "Deep Green", "Grey Melange",
    "French Navy", "Royal Blue" remain full colour names.
  */
  const comboParts = window.WSM_SPLIT_COLOUR_PARTS(raw);

  if (comboParts.length >= 2) {
    const comboColours = comboParts.slice(0, 3).map(function(part) {
      return window.WSM_GET_COLOUR(part, fallback);
    });

    return window.WSM_MAKE_GRADIENT(comboColours) || fallback;
  }

  const key = window.WSM_NORMALISE_COLOUR(raw);

  if (window.WSM_COLOUR_MAP[key]) {
    return window.WSM_COLOUR_MAP[key];
  }

  /*
    Soft prefix cleanup for names like:
    "Solid Black", "Classic Red", "Organic Natural", "Garment Dyed Khaki".
  */
  const simplified = key
    .replace(/^solid-/, '')
    .replace(/^classic-/, '')
    .replace(/^bright-/, '')
    .replace(/^dark-/, 'dark-')
    .replace(/^light-/, 'light-')
    .replace(/^new-/, '')
    .replace(/^organic-/, '')
    .replace(/^vintage-/, '')
    .replace(/^washed-/, '')
    .replace(/^garment-dyed-/, '')
    .replace(/^garment-dye-/, '')
    .replace(/^dtg-/, '')
    .replace(/^team-/, '')
    .replace(/^sport-/, '')
    .replace(/^sporty-/, '');

  if (window.WSM_COLOUR_MAP[simplified]) {
    return window.WSM_COLOUR_MAP[simplified];
  }

  const parts = key.split('-').filter(Boolean);

  /*
    Longest-ending fallback:
    "something black melange" -> black-melange
    "something hi vis yellow" -> hi-vis-yellow
    "something sapphire blue" -> sapphire-blue
  */
  for (let size = Math.min(5, parts.length); size >= 1; size--) {
    const tail = parts.slice(-size).join('-');

    if (window.WSM_COLOUR_MAP[tail]) {
      return window.WSM_COLOUR_MAP[tail];
    }
  }

  /*
    Anywhere fallback:
    Useful for values like "Heather Prism Dusty Blue" or "Organic Heather Grey Melange".
    Longest known phrase wins.
  */
  let bestKey = '';
  Object.keys(window.WSM_COLOUR_MAP).forEach(function(mapKey) {
    if (!mapKey || mapKey.length <= bestKey.length) return;

    if (key === mapKey || key.indexOf(mapKey) !== -1) {
      bestKey = mapKey;
    }
  });

  if (bestKey && window.WSM_COLOUR_MAP[bestKey]) {
    return window.WSM_COLOUR_MAP[bestKey];
  }

  return fallback;
};

window.WSM_GET_SWATCH_BACKGROUND = window.WSM_GET_COLOUR;